<template>
    <div>
    <a-drawer :title="searchConditionModel.ref01 == '' && searchConditionModel.relId == '' ? fieldMap.tlScanPack.displayName :
         (searchConditionModel.ref01 != '' &&  searchConditionModel.relId != '') ?  fieldMap.tlScanPack.displayName +'('+searchConditionModel.ref01 +'/'+ searchConditionModel.relId  + ')' :
          fieldMap.tlScanPack.displayName +'('+searchConditionModel.ref01+searchConditionModel.relId+')'

"  :visible="visible" width="95%" @close="closeScanPackPickToZero">
        <a-row style="display: flex;margin-left: 5px">
            <a-col :span="8" style="margin-top: 10px">
                <a-row style="display: flex;">
                    <a-col >
                         <div class="scanpackHeader">
                             <span class="tl-span" >{{ fieldMap.tlRef01.displayName }}:</span>
                              <a-input v-model="searchConditionModel.ref01" style="width: 65%; min-width: 100px"  @keydown.enter="searchOrderByInfoEnter" ref="tlRef01"
                                    :placeholder="$t('publicLang.PleaseEnter')" size="small" />
                              </div>
                    </a-col>

                    <a-col >
                        <div class="scanpackHeader">
                            <span class="tl-span" >{{ fieldMap.tlRelId.displayName }}:</span>
                            <a-input  v-model="searchConditionModel.relId" style="width: 65%"  @keydown.enter="searchOrderByInfoEnter" ref="tlRelId"
                                     :placeholder="$t('publicLang.PleaseEnter')" size="small" />
                        </div>
                    </a-col>


                    <a-col>
                        <div class="scanpackHeader">
                            <span class="tl-span" >{{ fieldMap.tlRef02.displayName }}:</span>
                            <a-input style="width: 65%;"
                                     v-model="searchConditionModel.ref02"   @keydown.enter="searchOrderByInfoEnter" ref="tlRef02"
                                     :placeholder="$t('publicLang.PleaseEnter')" size="small" />
                        </div>
                    </a-col>
                </a-row>
            </a-col>
            <a-col :span="16" style="padding-left: 8px" >

                <a-button  size="small" type="primary" class="tl-btn"  @click="cancelPackByPoClick" v-for="(item) in btnFunArr"  :key="item.code" v-if="item.code == 'CancelPickByPO' && item.arr.length > 0" :disabled="lockCancelPackByPOBtn ">
                    {{ item.arr[0].name }}
                </a-button>

                <a-button size="small" type="primary" class="tl-btn" @click="cancelPackBySoClick" v-for="(item) in btnFunArr"  :key="item.code"  v-if="item.code == 'CancelPickBySO' && item.arr.length > 0"  :disabled="lockCancelPackBySOBtn">
                    {{ item.arr[0].name }}
                </a-button>

                <a-button size="small" type="primary" class="tl-btn" @click="cancelPackByLineClick" v-for="(item) in btnFunArr" :key="item.code"   v-if="item.code == 'CancelPickByLine' && item.arr.length > 0"  :disabled="skuItemsBySscc.length > 0  || lockCancelPackByLineBtn">
                    {{ item.arr[0].name }}
                </a-button>

                <a-button size="small" type="primary" @click="importPackingClick(item.arr[0])"  v-for="(item) in btnFunArr" :key="item.code"  v-if="item.code == 'ImportPacking' && item.arr.length > 0"   :disabled="lockImportPacking"   class="tl-btn">
                    {{ item.arr[0].name }}
                </a-button>

                <a-button size="small" type="primary" class="tl-btn" @click="batchCloseCartonClick"  v-for="(item) in btnFunArr" :key="item.code"   v-if="item.code == 'BatchCloseCarton' && item.arr.length > 0"  :disabled="skuItemsBySscc.length > 0 || lockBatchCloseCartonBtn">
                    {{ item.arr[0].name }}
                </a-button>

                <a-button size="small" type="primary" class="tl-btn" @click="checkCompleteClick" v-for="(item) in btnFunArr" :key="item.code"  v-if="item.code == 'CheckComplete' && item.arr.length > 0"  :disabled="lockCheckCompleteBtn">
                    {{ item.arr[0].name }}
                </a-button>

                <a-button size="small" type="primary" class="tl-btn" @click="cancelCheckCompleteClick" v-for="(item) in btnFunArr" :key="item.code" v-if="item.code == 'CancelCheck' && item.arr.length > 0" :disabled="lockCancelCheckCompleteBtn">
                    {{ item.arr[0].name }}
                </a-button>

                <a-button size="small" type="primary" class="tl-btn" @click="closeOrderClick" v-for="(item) in btnFunArr" :key="item.code"  v-if="item.code == 'OrderClose' && item.arr.length > 0" :disabled="lockCloseOrderBtn">
                    {{ item.arr[0].name }}
                </a-button>

                <a-button size="small" type="primary" class="tl-btn" @click="reReprintClick" v-for="(item) in btnFunArr" :key="item.code"  v-if="item.code == 'Re-print' && item.arr.length > 0"  >
                    {{ item.arr[0].name }}
                </a-button>

                <a-button size="small" type="primary" class="tl-btn" v-for="item in btnFunArr" :key="item.code" v-if="item.code == 'Export' && item.arr.length > 0" :disabled="systemParam.scanpack_way == 'Y' && skuItemsBySscc.length > 0" @click="exportSkuTable">
                    {{ item.arr[0].name }}
                </a-button>

                <div  v-for="(item) in btnFunArr"  v-if="item.code == 'CourierEDI'" id="printPackList" style="display: inline-block;margin-left: 40px; margin-top: 10px;">
                        <a-dropdown-button v-if="item.arr.length  >  0">
                            {{ fieldMap.tlCourierEdi.displayName }}
                            <a-menu slot="overlay" >
                                <a-menu-item v-for="tt in item.arr" :key="tt.uid" @click="printPDFByBtnConfig(tt)">{{tt.name}}</a-menu-item>
                            </a-menu>
                        </a-dropdown-button>
                    </div>


                <div v-for="(item) in btnFunArr"  :key="item.code"  v-if="item.code == 'Print'" id="tlPrintList" style="display: inline-block;margin-left: 40px; margin-top: 10px;">
                    <a-dropdown-button v-if="item.arr.length  >  0">
                        {{ fieldMap.tlPrint.displayName }}
                        <a-menu slot="overlay" >
                            <a-menu-item v-for="tt in item.arr" :key="tt.uid" @click="printByBtnConfig(tt)">{{tt.name}}</a-menu-item>
                        </a-menu>
                    </a-dropdown-button>
                </div>
            </a-col>
      </a-row>
        <a-row style="display: flex;margin-left: 5px">
            <a-col :span="8" style="margin-top: 10px">
                <a-row style="display: flex;">
                    <a-col >
                        <div class="scanpackHeader">
                            <span class="tl-span" >{{ fieldMap.tlSku.displayName }}:</span>
                            <a-input v-model="searchConditionModel.sku"  style="width: 65%; min-width: 100px"  @keydown.enter="searchOrderByInfoEnter" ref="tlSku"
                                     :placeholder="$t('publicLang.PleaseEnter')" size="small" />
                        </div>
                    </a-col>

                    <a-col >
                        <div class="scanpackHeader">
                            <span class="tl-span" >{{ fieldMap.tlRef03.displayName }}:</span>
                            <a-input style="width: 65%"
                                     v-model="searchConditionModel.ref03" @keydown.enter="searchOrderByInfoEnter" ref="tlRef03"
                                     :placeholder="$t('publicLang.PleaseEnter')" size="small" />
                        </div>
                    </a-col>


                    <a-col>
                        <div class="scanpackHeader">
                            <span class="tl-span" >{{ fieldMap.tlRef04.displayName }}:</span>
                            <a-input style="width: 65%"
                                     v-model="searchConditionModel.ref04" @keydown.enter="searchOrderByInfoEnter" ref="tlRef04"
                                     :placeholder="$t('publicLang.PleaseEnter')" size="small" />
                        </div>
                    </a-col>
                </a-row>
            </a-col>
            <a-col :span="16" style="display: flex;margin-top: 10px;padding-left: 8px">
                <a-col >
                    <div class="scanpackHeader" >
                        <span class="tl-span" style="width: 100px">{{ fieldMap.tlAllowOverScan.displayName }}:</span>
                        <a-switch v-model="isAllowOverScan"  />
                    </div>
                </a-col>
                <a-col >
                    <div class="scanpackHeader" v-if="this.systemParam.scanpack_way != 'Y'">
                        <span class="tl-span" >{{ fieldMap.tlHiddenTable.displayName }}:</span>
                        <a-switch  v-model="isHiddenTable"  @change="changeHiddenTable" />
                    </div>
                </a-col>


            </a-col>
        </a-row>

        <a-divider style="margin: 10px 0"></a-divider>

        <a-row  v-if="!isHiddenTable" >
            <div id="orderTableId">
                <!-- 正常区域的框 -->
                <div class="vxe-table--cell-area" ref="cellarea">
                    <span class="vxe-table--cell-main-area"></span>
                    <span class="vxe-table--cell-active-area"></span>
                </div>
                <!-- 左边fixed区域的框,右边fixed没有尝试过。。。 -->
                <div id="leftcellarea" class="vxe-table--cell-area" ref="fixedcellarea">
                    <span class="vxe-table--cell-main-area"></span>
                    <span class="vxe-table--cell-active-area"></span>
                </div>

                <div id="rightcellarea" class="vxe-table--cell-area" ref="rightfixedcellarea">
                    <span class="vxe-table--cell-main-area"></span>
                    <span class="vxe-table--cell-active-area"></span>
                </div>

                <vxe-table
                        border
                        :data.sync="soOrderTable"
                        ref="skuTable"
                        class="mytable-style un-select-vxe-table"
                        :cell-class-name="cellClassName"
                        max-height="280"
                        show-footer
                        resizable
                        :footer-method="footerMethod"
                        :footer-cell-class-name="footerCellClassName"
                        size="mini"
                        :row-style="rowStyle"
                        v-bind="gridOptions"
                        @keydown="tableKeydown"
                        @cell-click="tableCellClick"
                        :keyboard-config="{ isArrow: true }"
                        stripe
                        highlight-hover-row
                        show-overflow
                >
                    <template v-slot:empty>
                        <span style="font-size: 12px; color: red;">{{ $t('pubGicSet.NoRecordfound') }}</span>
                    </template>
                    <vxe-table-column type="checkbox" width="34"></vxe-table-column>
                    <vxe-table-column field="ref01" :title="fieldMap.tbRef01.displayName" show-header-overflow="ellipsis" show-overflow="ellipsis"  width="90"></vxe-table-column>
                    <vxe-table-column field="ref02" :title="fieldMap.tbRef02.displayName" show-header-overflow="ellipsis" show-overflow="ellipsis"  width="54"></vxe-table-column>
                    <vxe-table-column field="ref03" :title="fieldMap.tbRef03.displayName" show-header-overflow="ellipsis" show-overflow="ellipsis"  width="52"></vxe-table-column>
                    <vxe-table-column field="sscc" :title="fieldMap.tbSscc.displayName" show-header-overflow="ellipsis" show-overflow="ellipsis" width="160"></vxe-table-column>
                    <vxe-table-column field="cartonStatus" :title="fieldMap.tbStatus.displayName" show-header-overflow="ellipsis" show-overflow="ellipsis" width="34">
                      <template v-slot="{row}"><span :style="colStyle(row.cartonStatus)">{{row.cartonStatus}}</span></template>
                    </vxe-table-column>
                    <vxe-table-column field="sku" :title="fieldMap.tbSku.displayName" show-header-overflow="ellipsis" show-overflow="ellipsis"  width="110"></vxe-table-column>
                    <vxe-table-column field="style" :title="fieldMap.tbStyle.displayName" show-header-overflow="ellipsis" show-overflow="ellipsis"  width="84"></vxe-table-column>
                    <vxe-table-column field="color" :title="fieldMap.tbColor.displayName" show-header-overflow="ellipsis" show-overflow="ellipsis"  width="84"></vxe-table-column>
                    <vxe-table-column field="size" :title="fieldMap.tbSize.displayName" show-header-overflow="ellipsis" show-overflow="ellipsis"  width="54"></vxe-table-column>
                    <vxe-table-column field="allBaseQty" :title="fieldMap.tbAllocateQty.displayName" show-header-overflow="ellipsis" show-overflow="ellipsis"  width="70"></vxe-table-column>
                    <vxe-table-column field="packedBaseQty" :title="fieldMap.tbPackedQty.displayName" show-overflow show-header-overflow width="70"></vxe-table-column>
                    <vxe-table-column field="unpackedBaseQty" :title="fieldMap.tbOutstandingQty.displayName" show-header-overflow="ellipsis" show-overflow="ellipsis" width="68"></vxe-table-column>
                    <vxe-table-column field="descr" :title="fieldMap.tbDescr.displayName" show-header-overflow="ellipsis" show-overflow="ellipsis"  width="154"></vxe-table-column>
                    <vxe-table-column field="relId" :title="fieldMap.tbRelId.displayName" show-header-overflow="ellipsis" show-overflow="ellipsis"  width="150"></vxe-table-column>
                </vxe-table>
            </div>
        </a-row>


<a-row style="display: flex">
    <a-col :span="12" >
        <a-row>
            <a-form  class="ant-advanced-search-form">
                <a-row :gutter="24" style="margin-top: 5px">
                    <a-col :span="8">
                        <a-form-item :label="fieldMap.scSku.displayName">
                            <input
                                    ref="scSku"
                                    v-model="scSku"
                                    :disabled="lockScSku"
                                    style="width: 100%;"
                                    :placeholder="$t('publicLang.PleaseEnter')"
                                    size="small"
                                    @keydown.enter= "scSkuEnterEvent"
                            />
                        </a-form-item>
                    </a-col>
                    <a-col :span="5">
                        <a-form-item :label="fieldMap.scQty.displayName">
                            <a-input-number id="inputNumber"
                                            ref="scQty"
                                            v-model="scQty"
                                            :disabled="lockScQty"
                                            :min="1"
                                            style="width: 100%;"
                                            :placeholder="$t('publicLang.PleaseEnter')"
                                            size="small"
                                            @keydown.enter= "scQtyEnterEvent"
                            />
                        </a-form-item>
                    </a-col>

                    <a-col :span="4"   style="padding-right: 0px" >
                        <a-form-item  :label="fieldMap.scLockScanQty.displayName"  style=" display: flex;align-items: center;">
                            <a-checkbox :checked="lockScQty" @change="lockScQtyEvent"></a-checkbox>
                        </a-form-item>
                    </a-col>


                    <a-col :span="6"    >
                        <a-form-item :label="fieldMap.scRemoveScanItem.displayName" style=" display: flex;align-items: center;">
                            <a-checkbox :checked="lockScRemoveScanItem" @change="lockScRemoveScanItemEvent" ></a-checkbox>
                        </a-form-item>
                    </a-col>
                </a-row>
            </a-form>
        </a-row>

        <a-row  type="flex" justify="start">
            <a-col  style="margin-left: 100px;margin-top: -10px;">
                <p class="scanCodeTile">{{ fieldMap.scPackedQty.displayName }}</p>
                <div style="font-size: 100px;color: #23B14D;font-weight: bold;margin-top: -30px;">
                    <p>{{sumPackedQty}}</p>
                </div>
            </a-col>

            <a-col style="margin-left: 100px;margin-top: -10px;">
                <p class="scanCodeTile">{{ fieldMap.scUnpackQty.displayName }}</p>
                <div style="color: #ED1D25;font-size: 100px;font-weight: bold;margin-top: -30px;">
                    <p>{{sumUnpackQty}}</p>
                </div>
            </a-col>

        </a-row>


        <a-row style="margin-left: 10px;">
            <transition name="slide-fade">
                <a-row>
                    <a-row>
                        <a-spin :spinning="editSpin">
                            <a-form >
                                <a-row :gutter="24" style="margin-right: 10px">
                                    <a-col :span="8">
                                        <a-form-item class="genericFrom" :label="fieldMap.pcCartonNo.displayName">
                                            <a-input
                                                    :disabled="true"
                                                    v-model="cartonInfo.cartonNo"
                                                    size="small"
                                                    :placeholder="$t('publicLang.PleaseEnter')"
                                                    style="width:100%"
                                            />
                                        </a-form-item>
                                    </a-col>

                                    <a-col :span="8">
                                        <a-form-item class="genericFrom" :label="fieldMap.pcCartonType.displayName">
                                            <a-select
                                                    show-search
                                                    optionFilterProp="label"
                                                    :placeholder="$t('publicLang.PleaseSelect')"
                                                    style="width: 100%"
                                                    size="small"
                                                    v-model="cartonInfo.cartonType"
                                                    @change="cartonTypeChange"
                                            >
                                                <a-select-option :label="item"  :value="item.cartonType" :key="item.cartonType" v-for="item in this.systemParam.CARTON_MASTER_LIST">{{item.cartonType}}</a-select-option>
                                            </a-select>
                                        </a-form-item>
                                    </a-col>



                                    <a-col :span="8">
                                        <a-form-item class="genericFrom" :label="fieldMap.pcTrackingNo.displayName">
                                            <a-input
                                                    :disabled="this.systemParam.TRACKING_NO_EDIT == null ? true :   'Y' == this.systemParam.TRACKING_NO_EDIT ? false : true "
                                                    v-model="cartonInfo.logisticsid"
                                                    :placeholder="$t('publicLang.PleaseEnter')"
                                                    size="small"
                                                    style="width:100%"/>
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="8">
                                        <a-form-item class="genericFrom" :label="fieldMap.pcLength.displayName">
                                            <a-input-number
                                                    v-model="cartonInfo.length"
                                                    size="small"
                                                    :min="0"
                                                    :placeholder="$t('publicLang.PleaseEnter')"
                                                    style="width:100%"
                                            />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="8">
                                        <a-form-item class="genericFrom" :label="fieldMap.pcWidth.displayName">
                                            <a-input-number
                                                    v-model="cartonInfo.width"
                                                    size="small"
                                                    :min="0"
                                                    :placeholder="$t('publicLang.PleaseEnter')"
                                                    style="width:100%"/>
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="8">
                                        <a-form-item class="genericFrom" :label="fieldMap.pcHeight.displayName">
                                            <a-input-number
                                                    v-model="cartonInfo.height"
                                                    size="small"
                                                    :min="0"
                                                    :placeholder="$t('publicLang.PleaseEnter')"
                                                    style="width:100%"/>
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="8">
                                        <a-form-item class="genericFrom" :label="fieldMap.pcDimUom.displayName">
                                            <a-input
                                                    v-model="cartonInfo.dimensionUom"
                                                    :placeholder="$t('publicLang.PleaseEnter')"
                                                    size="small"
                                                    style="width:100%"/>
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="8">
                                        <a-form-item class="genericFrom" :label="fieldMap.pcCbm.displayName">
                                            <a-input-number
                                                    v-model="cartonInfo.cbm"
                                                    size="small"
                                                    :min="0"
                                                    ref="cbmRef"
                                                    :placeholder="$t('publicLang.PleaseEnter')"
                                                    style="width:100%"/>
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="8">
                                        <a-form-item class="genericFrom" :label="fieldMap.pcWeight.displayName">
                                            <a-input
                                                    v-model="cartonInfo.grossWeight"
                                                    :placeholder="$t('publicLang.PleaseEnter')"
                                                    size="small"
                                                    ref="weightRef"
                                                    style="width:100%"/>
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="8">
                                        <a-form-item class="genericFrom" :label="fieldMap.pcWeightUom.displayName">
                                            <a-input
                                                    v-model="cartonInfo.weightUom"
                                                    :placeholder="$t('publicLang.PleaseEnter')"
                                                    size="small"
                                                    style="width:100%"/>
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="8">
                                        <a-form-item class="genericFrom" :label="fieldMap.pcUserdefined1.displayName">
                                            <a-input
                                                    v-model="cartonInfo.userdefined1"
                                                    :placeholder="$t('publicLang.PleaseEnter')"
                                                    size="small"
                                                    style="width:100%"/>
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="8">
                                        <a-form-item class="genericFrom" :label="fieldMap.pcUserdefined2.displayName">
                                            <a-input
                                                    v-model="cartonInfo.userdefined2"
                                                    :placeholder="$t('publicLang.PleaseEnter')"
                                                    size="small"
                                                    style="width:100%"/>
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="8">
                                        <a-form-item class="genericFrom" :label="fieldMap.pcUserdefined3.displayName">
                                            <a-input
                                                    v-model="cartonInfo.userdefined3"
                                                    :placeholder="$t('publicLang.PleaseEnter')"
                                                    size="small"
                                                    style="width:100%"/>
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="8">
                                        <a-form-item class="genericFrom" :label="fieldMap.pcUserdefined4.displayName">
                                            <a-input
                                                    v-model="cartonInfo.userdefined4"
                                                    :placeholder="$t('publicLang.PleaseEnter')"
                                                    size="small"
                                                    style="width:100%"/>
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="8">
                                        <a-form-item class="genericFrom" :label="fieldMap.pcUserdefined5.displayName">
                                            <a-input
                                                    v-model="cartonInfo.userdefined5"
                                                    :placeholder="$t('publicLang.PleaseEnter')"
                                                    size="small"
                                                    style="width:100%"/>
                                        </a-form-item>
                                    </a-col>
                                </a-row>
                            </a-form>

                        </a-spin>
                    </a-row>
                </a-row>
            </transition>
        </a-row>





    </a-col>


    <a-col  :span="12">
        <a-tabs v-model="scanpackTabsTarget"  @change="scanpackTabsEvent"   tabPosition="top" size="small">
            <a-tab-pane :tab="$t('pubGicSet.Detail')" key="1">
                <a-row type="flex" justify="start">
                    <a-col style="margin-left: 20px;">
                        <p class="scanCodeTile">{{ fieldMap.pdAllocatedQty.displayName }}</p>
                        <div class="radiusback" style="background: #009900;">
                            <i>{{pdAllocatedQty}}</i>
                        </div>
                    </a-col>
                    <a-col style="margin-left: 20px;">
                        <p class="scanCodeTile">{{ fieldMap.pdPackedQty.displayName }}</p>
                        <div class="radiusback" style="background: #6666ff;">
                            <i>{{pdPackedQty}}</i>
                        </div>
                    </a-col>
                    <a-col style="margin-left: 20px;">
                        <p class="scanCodeTile">{{ fieldMap.pdPercentage.displayName }}</p>
                        <div class="radiusback" style="background: #f69;"><i style="font-size: 50px">{{pdPercentage}}</i></div>
                    </a-col>
                    <a-col style="margin-left: 20px;">
                        <p class="scanCodeTile">{{fieldMap.pdNoOfCarton.displayName}}</p>
                        <div class="radiusback" style="background: #699;"><i>{{pdNoOfCarton}}</i></div>
                    </a-col>
                </a-row>
                <a-divider style="margin: 10px 0"></a-divider>
                <a-row>
                    <vxe-table
                            border
                            resizable
                            :data.sync="packDetailTable"
                            size="mini"
                            max-height="330"
                            @cell-click="scanpackDetailTableEvnt"
                    >
                        <template v-slot:empty>
                            <span style="font-size: 12px; color: red;">{{ $t('pubGicSet.NoRecordfound') }}</span>
                        </template>
                        <vxe-table-column type="checkbox" width="50"></vxe-table-column>
                        <vxe-table-column
                                width="200"
                                show-header-overflow="ellipsis" show-overflow="ellipsis"
                                field="relId"
                                :title="fieldMap.tlRelId.displayName"
                        ></vxe-table-column>

                        <vxe-table-column
                                width="200"
                                show-header-overflow="ellipsis" show-overflow="ellipsis"
                                field="cartonNo"
                                :title="fieldMap.tbPcCartonNo.displayName"
                        ></vxe-table-column>
                        <vxe-table-column
                                width="200"
                                show-header-overflow="ellipsis" show-overflow="ellipsis"
                                field="qty"
                                :title="fieldMap.tbPcPackedQty.displayName"
                        ></vxe-table-column>
                        <vxe-table-column
                                width="200"
                                show-header-overflow="ellipsis" show-overflow="ellipsis"
                                field="creator"
                                :title="fieldMap.tbPcCreatedBy.displayName"
                        ></vxe-table-column>
                    </vxe-table>
                </a-row>
            </a-tab-pane>



            <a-tab-pane :tab="$t('pubGicSet.Carton')" key="2">
                <a-row type="flex" justify="start">
                    <a-col v-for="item in btnFunArr" :key="item.uid" style="margin-top: 10px">

                        <div v-if="item.code == 'SaveCarton' && item.arr.length > 0 " style="margin-left: 4px;">
                            <a-button
                                    :disabled="cartonInfo.uid == null ? true:  cartonInfo.uid == '' ? true : cartonInfo.uid == '-1' ? true : false "
                                    size="small"
                                    type="primary"
                                    @click="saveCartonEvent"
                            > {{ item.arr[0].name }}</a-button>
                        </div>


                        <div v-if="item.code == 'CloseCarton' && item.arr.length > 0 " style="margin-left: 4px;">
                            <a-button
                                    :disabled="cartonInfo.uid == null ? true:  cartonInfo.uid == '' ? true : false "
                                    size="small"
                                    type="primary"
                                    @click="closeCartonEvent"
                            > {{ item.arr[0].name }}</a-button>
                        </div>


                        <div v-if="item.code == 'RemoveCarton' && item.arr.length > 0 " style="margin-left: 4px;">
                            <a-button
                                    size="small"
                                    type="primary"
                                    :disabled="cartonInfo.uid == null ? true:  cartonInfo.uid == '' ? true : false "
                                    @click="removeCartonEvent"
                            > {{ item.arr[0].name }}</a-button>
                        </div>


                        <div v-if="item.code == 'AppendCarton' && item.arr.length > 0 "   style="margin-left: 4px;">
                            <a-button
                                    :disabled="cartonInfo.uid == null ? true:  cartonInfo.uid == '' ? true :  cartonInfo.uid == '-1' ? true : false "
                                    size="small"
                                    type="primary"
                                    @click="appendCartonEvent"
                            > {{ item.arr[0].name }}</a-button>
                        </div>





                        <div v-if="item.code == 'D-Print' && item.arr.length > 0 " style="margin-left: 4px;">
                            <a-button
                                    v-if="item.arr.length == 1"
                                    style="margin-left: 4px;"
                                    size="small"
                                    type="primary"
                                    @click="printByBtnConfig(item.arr[0])"
                            > {{ item.arr[0].name }}</a-button>
                            <a-dropdown-button v-else-if="item.arr.length > 1"  >
                                {{ fieldMap.tlPrint.displayName }}
                                <a-menu slot="overlay" >
                                    <a-menu-item v-for="(tt,index) in item.arr" :key="index"  @click="printByBtnConfig(tt)">{{tt.name}}</a-menu-item>
                                </a-menu>
                            </a-dropdown-button>
                        </div>



                        <!--  Other  -->
                        <div v-if="item.code == 'Other'" style="margin-left: 4px;">
                            <a-button
                                    v-for="tt in item.arr"
                                    :key="tt.uid"
                                    style="margin-left: 4px;"
                                    size="small"
                                    type="primary"
                                    @click="printByBtnConfig(tt)"
                            >{{ tt.name }}</a-button>
                        </div>

                    </a-col>
                </a-row>
                <a-row>
                    <a-col :span="24" >
                        <a-row
                                type="flex"
                                justify="start"
                                style="margin: 10px 0 0 0;">
                            <a-col>
                                <div class="scanpackHeader">
                                    <div class="scanpackTitle" style="width: 210px"> {{ fieldMap.scSscc.displayName }}:</div>
                                    <a-input
                                            :disabled="lockScSscc"
                                            v-model="cartonInfo.sscc"
                                            :placeholder="$t('publicLang.PleaseEnter')"
                                            size="small"
                                            @pressEnter="cartonSearchEnter"
                                            ref="cartonNorefs"/>
                                </div>
                            </a-col>

                            <a-col>
                                <a-row  style="display: flex;align-items: center;margin-left: 20px;justify-content: start;">
                                    <a-col style="display: flex">
                                        <span style="display: inline-block;padding-right: 5px;margin: auto;">{{ fieldMap.scCartonQty.displayName }}:</span>
                                        <a-input  style="width: 70px;" :placeholder="$t('publicLang.PleaseEnter')" v-model="cartonQty"
                                                  size="small"/>
                                    </a-col>
                                    <a-col style="margin-left: 5px"> <a-checkbox v-model="lockScCartonQty"
                                                                                 @change="cartonQtyCheckboxChange" ></a-checkbox></a-col>
                                </a-row>
                            </a-col>

                        </a-row>
                        <transition name="slide-fade">
                            <a-row>
                                <a-row type="flex" justify="start" style="margin: 10px 0">
                                    <a-col style="margin-left: 100px;">
                                        <p class="scanCodeTile">{{ fieldMap.pcPackedQty.displayName }}</p>
                                        <div style="color: black;font-size: 70px;font-weight: bold;">
                                            <p>{{sumCartonPackQty}}</p>
                                        </div>
                                    </a-col>
                                    <a-col style="margin-left: 100px;">
                                        <p class="scanCodeTile">{{  fieldMap.pcNoOfSku.displayName  }}</p>
                                        <div style="color: black;font-size: 70px;font-weight: bold;">
                                            <p>{{sumCartonSku}}</p>
                                        </div>
                                    </a-col>
                                </a-row>
                                <a-row style="margin-right: 10px;">
                                    <vxe-table
                                            border
                                            resizable
                                            :data.sync="cartonTable"
                                            size="mini"
                                            max-height="330"
                                            class="mytable-style "
                                            :cell-class-name="cartonTableClass"
                                    >
                                        <template v-slot:empty>
                                            <span style="font-size: 12px; color: red;"> </span>
                                        </template>
                                        <vxe-table-column type="checkbox" width="50"></vxe-table-column>
                                        <vxe-table-column
                                                width="300"
                                                show-header-overflow="ellipsis" show-overflow="ellipsis"
                                                field="sku"
                                                :title="fieldMap.tbPcSku.displayName "
                                        >
                                        </vxe-table-column>
                                        <vxe-table-column
                                                width="100"
                                                show-header-overflow="ellipsis" show-overflow="ellipsis"
                                                field="uom"
                                                :title="fieldMap.tbPcUom.displayName ">
                                        </vxe-table-column>
                                        <vxe-table-column
                                                show-header-overflow="ellipsis" show-overflow="ellipsis"
                                                field="descr"
                                                :title="fieldMap.tbPcDescr.displayName "
                                        ></vxe-table-column>
                                        <vxe-table-column
                                                show-header-overflow="ellipsis" show-overflow="ellipsis"
                                                field="scannedQty"
                                                :title="fieldMap.tbPcScannedQty.displayName "
                                        ></vxe-table-column>
                                    </vxe-table>
                                </a-row>
                            </a-row>
                        </transition>

                    </a-col>
                </a-row>
            </a-tab-pane>


        </a-tabs>


    </a-col>


</a-row>

    </a-drawer>




        <a-modal
                :title="$t('pubGicSet.Error')"
                v-model="isAlertError"
                width="40%"
                @cancel="cancelAlertError"
                :maskClosable="false"
                :footer="null"
        >

            <audio
                    controls="controls"
                    autoplay="autoplay"
                    loop="loop"
                    id="scanErrorMusic"
                    hidden
            >
                <source src="../../../assets/mm.mp3" type="audio/mpeg" />
            </audio>


            <a-alert type="error">
                <p
                        slot="description"
                        style="color: red;font-size: 30px;padding: 50px 0;text-align: center;line-height: 30px;"
                >
                    {{scanErrorMsg}}
                </p>
            </a-alert>


        </a-modal>

        <audio
                controls="controls"
                ref="scanSuccessMusicRef"
                hidden>
            <source src="../../../assets/scan_success.mp3" type="audio/mpeg" />
        </audio>

        <import-modal
                ref="importModal"
                :visible="importVisible"
                v-on:cancelImport="GETcancelImport"
                :importparams="importparams"
        ></import-modal>


    </div>
</template>

<script>
    import ajax from "../../../api/ajax";
    import api from "../../../api/url";

    import { mapState } from "vuex";
    import XEClipboard from 'xe-clipboard';
    import axios from "axios";
    import webSocketPrint from "./webSocketPrint";
    import cookie from "../../../api/cookie";
    import importModal from "../components/importModal";

    export default {
        components: {
            importModal,
        },
        data() {
            return {
                gridOptions:{
                    //列配置 (使用列拖拽功能,必须配置useKey为true)
                    "column-config":{resizable:true},
                    //边框
                    border:"full",
                    //斑马纹
                    stripe:true,
                    //列信息
                    //这里一定要指定true，否则row-config的height没用
                    'show-overflow':true,
                    //行配置,这里的行高一定需要指定
                    "row-config":{isCurrent:true,height:30,isHover:true},
                },
                importVisible: false,
                importparams: {},
                visible: false,
                isAllowOverScan: false,
                lockCancelPackByPOBtn: true,
                lockCancelPackBySOBtn: true,
                lockCancelPackByLineBtn: true,
                lockBatchCloseCartonBtn:true,
                lockCheckCompleteBtn: true,
                lockCancelCheckCompleteBtn: true,
                lockCloseOrderBtn: true,
                lockImportPacking: true,
                cartonQty: null,
                lockScCartonQty: false,
                // lockAppendBtn: true,
                // lockRemoveBtn: true,
                // lockCloseBtn: true,
                isHiddenTable: false,
                searchConditionModel:{
                    ref01: "",
                    relId: "",
                    sku: "",
                    ref02: "",
                    ref03: "",
                    ref04: "",
                    soUid: "",
                },
                cartonTableSKU: "",
                isAlertError: false,
                scanErrorMsg: "",
                scSku: "",
                scQty:1,
                lockScQty: true,
                lockScSku: false,
                lockScSscc: false,
                lockScRemoveScanItem: false,
                soOrderTable: [],
                cartonInfo:{
                    uid: "",
                    relId:"",
                    sscc: "",
                    cartonNo: "",
                    cartonType: null,
                    logisticsid:"",
                    length: "",
                    width: "",
                    height: "",
                    dimensionUom: "",
                    cbm: "",
                    grossWeight: "",
                    weightUom: "",
                    userdefined1: "",
                    userdefined2: "",
                    userdefined3: "",
                    userdefined4: "",
                    userdefined5: ""
                },
                editSpin: false, // 编辑加载提示
                scanpackTabsTarget: '2',
                cartonTable:[],
                packDetailTable:[],
                sumPackedQty: 0 ,
                sumUnpackQty: 0,
                sumCartonPackQty : 0,
                sumCartonSku: 0,
                pdAllocatedQty: 0,
                pdPackedQty: 0,
                pdPercentage: 0,
                pdNoOfCarton: 0,
                btnFunArr: [
                    {code: 'CancelPickByPO',arr:[]},
                    {code: 'CancelPickBySO',arr:[]},
                    {code: 'CancelPickByLine',arr:[]},
                    {code: 'ImportPacking',arr:[]},
                    {code: 'BatchCloseCarton',arr:[]},
                    {code: 'CheckComplete',arr:[]},
                    {code: 'CancelCheck',arr:[]},
                    {code: 'OrderClose',arr:[]},
                    {code: 'SaveCarton',arr:[]},
                    {code: 'CloseCarton',arr:[]},
                    {code: 'AppendCarton',arr:[]},
                    {code: 'RemoveCarton', arr:[]},
                    {code: 'CourierEDI',arr:[]},
                {code: 'Print',arr:[]},
                {code: 'Re-print',arr:[]},
                {code: 'D-Print',arr:[]},
                {code: 'Other',arr:[]},
                {code: 'Export',arr:[]}
                ],
                fieldMap:{
                    pcCartonNo:{},
                    pcCartonType:{},
                    pcCbm:{},
                    pcDimUom:{},
                    pcHeight:{},
                    pcLength:{},
                    pcNoOfSku:{},
                    pcPackedQty:{},
                    pcTrackingNo:{},
                    pcUserdefined1:{},
                    pcUserdefined2:{},
                    pcUserdefined3:{},
                    pcUserdefined4:{},
                    pcUserdefined5:{},
                    pcWeight:{},
                    pcWeightUom:{},
                    pcWidth:{},
                    pdAllocatedQty:{},
                    pdNoOfCarton:{},
                    pdPackedQty:{},
                    pdPercentage:{},
                    scCartonQty:{},
                    scLockScanQty:{},
                    scPackedQty:{},
                    scQty:{},
                    scRemoveScanItem:{},
                    scSku:{},
                    scSscc:{},
                    scUnpackQty:{},
                    tbAllocateQty:{},
                    tbDescr:{},
                    tbOutstandingQty:{},
                    tbPackedQty:{},
                    tbPcCartonNo:{},
                    tbPcCreatedBy:{},
                    tbPcDescr:{},
                    tbPcPackedQty:{},
                    tbPcScannedQty:{},
                    tbPcSku:{},
                    tbPcUom:{},
                    tbRef01:{},
                    tbRef02:{},
                    tbRef03:{},
                    tbRelId:{},
                    tbSku:{},
                    tbStyle:{},
                    tbColor:{},
                    tbSize:{},
                    tbSscc:{},
                    tbStatus:{},
                    tlAllowOverScan:{},
                    tlCourierEdi:{},
                    tlHiddenTable:{},
                    tlPrint:{},
                    tlRef01:{},
                    tlRef02:{},
                    tlRef03:{},
                    tlRef04:{},
                    tlRelId:{},
                    tlScanPack:{},
                    tlSku:{}
                },
               ip:"",
               printers:[],
               skuItemsBySscc:[], // 存放缓存扫描的List
            };
        },
        computed: {
            ...mapState(["systemParam"])
        },
        mounted(){
            this.getUserIP((ip) => {
                this.ip = ip;
            });
        },

        methods: {
            exportSkuTable(){
                if (this.systemParam.scanpack_way == 'Y' && this.skuItemsBySscc.length > 0) {
                    return;
                }
                const exportData = () => {
                    this.$nextTick(() => {
                        const table = this.$refs.skuTable;
                        if (table) {
                            const columns = table.getColumns ? table.getColumns() : (table.visibleColumn || []);
                            const originalWidths = columns.map(column => column.renderWidth);
                            const exportColumnWidth = 150;
                            columns.forEach(column => {
                                column.renderWidth = exportColumnWidth;
                            });
                            try {
                                table.exportData({
                                    filename: 'Pick To Zero',
                                    type: 'xlsx',
                                    isHeader: true,
                                    isFooter: false,
                                    columnFilterMethod: ({ column }) => {
                                        return ['checkbox', 'selection', 'radio'].indexOf(column.type) === -1;
                                    }
                                });
                            } finally {
                                columns.forEach((column, index) => {
                                    column.renderWidth = originalWidths[index];
                                });
                            }
                        }
                    });
                };
                const hasParams = Object.keys(this.searchConditionModel || {}).some(key => {
                    const value = this.searchConditionModel[key];
                    return value !== null && value !== undefined && String(value).trim() !== '';
                });
                if (!hasParams) {
                    exportData();
                    return;
                }
                this.searchOrderByInfo().then(() => {
                    exportData();
                });
            },
            reReprintClick(){
                // console.info("666")
                let  params = JSON.parse(JSON.stringify(this.searchConditionModel));
                params.sscc = this.cartonInfo == null ? "" : this.cartonInfo.sscc;
                params.ip = this.ip
                this.getPrinters();
                ajax.get(api.AUTOPRINT,params).then(res => {
                    this.autoPrint(res);
                })
            },
            importPackingClick(btnConfig){
                let params = {}
                params.btnUid=btnConfig.uid;
                params.importTitle="Import";
                params.importType = "excel";
                params.gmcUid = btnConfig.gmcUid;
                this.importparams = params;
                this.importVisible = true;
            },
            GETcancelImport(val) {
                if (! this.searchConditionModelisEmpty()){
                    this.searchOrderByInfo();
                }
                this.importVisible = false;
            },
            changeHiddenTable(){
                if (! this.isHiddenTable){
                    this.searchOrderByInfo().then(() => {
                        this.addListener();
                       this.cartonSearchEnter();
                        // this.computeCartonTable(params.scSku,currentScanQty)
                    }).catch(error => {
                        console.error('error :', error);
                    });
                }
            },
            getUserIP (onNewIP) {
                let MyPeerConnection = window.RTCPeerConnection || window.mozRTCPeerConnection || window.webkitRTCPeerConnection
                let pc = new MyPeerConnection({
                    iceServers: []
                })
                let noop = () => {

                }
                let localIPs = {}
                let ipRegex = /([0-9]{1,3}(\.[0-9]{1,3}){3}|[a-f0-9]{1,4}(:[a-f0-9]{1,4}){7})/g
                let iterateIP = (ip) => {
                    if (!localIPs[ip]) onNewIP(ip)
                    localIPs[ip] = true
                }
                pc.createDataChannel('')
                pc.createOffer().then((sdp) => {
                    sdp.sdp.split('\n').forEach(function (line) {
                        if (line.indexOf('candidate') < 0) return
                        line.match(ipRegex).forEach(iterateIP)
                    })
                    pc.setLocalDescription(sdp, noop, noop)
                }).catch((reason) => {
                })
                pc.onicecandidate = (ice) => {
                    if (!ice || !ice.candidate || !ice.candidate.candidate || !ice.candidate.candidate.match(ipRegex)) return
                    ice.candidate.candidate.match(ipRegex).forEach(iterateIP)
                }
            },

            cartonQtyCheckboxChange(event){
                const checked = event.target.checked;
                if (checked){
                    this.cartonQty = this.sumMaxCartonQty();
                }else {
                    this.cartonQty = null;
                }
            },
            sumMaxCartonQty(){
                let sumCartonQty = 0;
                let orderStats = new Map();
                if (this.soOrderTable == null || this.soOrderTable.length == 0 || this.cartonTable == null || this.cartonTable.length == 0 ){
                    return  0;
                }
                this.soOrderTable.forEach(item => {
                    const { relId, sku, unpackedBaseQty } = item;
                    if (!orderStats.has(relId)) {
                        orderStats.set(relId, new Map());
                    }
                    const order = orderStats.get(relId);
                    order.set(sku, (order.get(sku) || 0) + unpackedBaseQty);
                });


                for (const [relId, skus] of orderStats) {
                    let minGroups = Number.MAX_VALUE;
                    this.cartonTable.forEach(ratio => {
                        const sku = ratio.sku;
                        const available = skus.get(sku) || 0;
                        const possibleGroups = Math.floor(available / ratio.scannedQty);
                        minGroups = Math.min(minGroups, possibleGroups);
                    });

                    sumCartonQty += minGroups
                }
                return sumCartonQty;
            },
            searchOrderByInfoEnter(){
                if(this.searchConditionModelisEmpty()) {
                    this.init();
                    this.initCartonInfo();
                    return;
                }
                this.scSku =  "";
                this.lockScQty  = true;
                this.lockScRemoveScanItem  = false;
                this.lockScSku = false;
                this.isHiddenTable = false;
                this.isAllowOverScan = false;
                this.skuItemsBySscc = [];
                this.initCartonInfo();
                this.searchOrderByInfo('titleSearch');
            },
            closeCartonEvent(){
                let params = {
                    sscc: this.cartonInfo.sscc
                };
                if (this.cartonQty != 0){  //this.lockScCartonQty &&
                    let number = this.sumMaxCartonQty();
                    if (this.cartonQty > number ){
                        this.$customMessage.error( this.$i18n.t('pubGicSet.cartonQtyTooLarge'),3);
                        return
                    }
                    params.cartonQty = this.cartonQty;
                    params.searchCondition=this.searchConditionModel;
                    params.cartonInfo = this.cartonInfo;
                    params.skuItems = this.skuItemsBySscc;
                }

                ajax.post(api.PICKTOZEROCARTONCLOSE, params).then(res => {
                    if (res.code == 200) {
                        this.$message.success(res.msg,3)
                        this.skuItemsBySscc=[];
                        this.initCartonInfo();
                        this.searchOrderByInfo();
                        this.closeCartonAutoPrint(res.data)
                    }else {
                        this.$customMessage.error(res.msg,3);
                    }

                });
            },
            closeCartonAutoPrint(sscc){
                if(sscc != null){
                    let  params = JSON.parse(JSON.stringify(this.searchConditionModel));
                    params.sscc = sscc;
                    params.ip = this.ip
                    this.getPrinters();
                    ajax.get(api.AUTOPRINT,params).then(res => {
                        this.autoPrint(res);
                    })
                }
            },
            getPrinters(){
                let that = this;
                if ("WebSocket" in window)
                {
                    // Create websocket
                    var ws = new WebSocket("ws://localhost:9999/print");
                    ws.onopen = function()
                    {
                        ws.send("{'Type':'SERVER_INFO'}");
                    };
                    ws.onmessage = function (evt)
                    {
                        var msg = evt.data;
                        try {
                            that.printers = JSON.parse(msg).printerServer.printers;
                        } catch (e) {
                        }

                    };
                    ws.onclose = function()
                    {

                    };
                }
                else
                {

                }
            },
            /**
             * 优化后的自动打印函数
             * @param {Array} res 打印任务列表
             */
            async  autoPrint(res) {
                // 辅助函数：用于在循环中产生微小的延迟，让出主线程执行权
                const sleep = (ms) => new Promise(resolve => setTimeout(resolve, ms));

                for (let i = 0; i < res.length; i++) {
                    // 1. 基础合法性校验
                    if (res[i] == null || res[i].type == null) {
                        continue;
                    }
                    if (res[i].errorMsg != null && res[i].errorMsg !== "") {
                        continue;
                    }
                    if (res[i].printerName == null || res[i].printerName === "") {
                        continue;
                    }


                    // 2. 匹配本地打印机逻辑
                    let printerName = "";
                    let printerNames = res[i].printerName.split(",");
                    for (let j = 0; j < this.printers.length; j++) {
                        for (let k = 0; k < printerNames.length; k++) {
                            if (this.printers[j].name === printerNames[k]) {
                                printerName = printerNames[k];
                                break;
                            }
                        }
                        if (printerName !== "") break;
                    }


                    // 3. 开始执行推送逻辑
                    if (printerName !== "") {
                        res[i].printerName = printerName;
                        const CHUNK_SIZE = 125000; // 每片大小

                        if (res[i].fileBytes.length > CHUNK_SIZE) {
                            let rawData = res[i].fileBytes;
                            let totalLength = rawData.length;
                            let partCount = Math.ceil(totalLength / CHUNK_SIZE); // 分批数

                            for (let j = 0; j < partCount; j++) {
                                // 提取当前分片数据
                                let start = j * CHUNK_SIZE;
                                let end = Math.min(start + CHUNK_SIZE, totalLength);
                                let chunkData = rawData.substring(start, end);

                                // 构造发送对象
                                res[i].fileIndex = j;      // 当前包序号
                                res[i].fileCount = partCount; // 总包数
                                res[i].fileBytes = chunkData;

                                // 发送数据
                                webSocketPrint.doPrint("9999", JSON.stringify(res[i]));

                                // --- 核心修复：防止 256 报错的关键 ---
                                // 每发送 1 个包，强制异步休眠 10 毫秒
                                // 这允许浏览器将数据真正写入网卡缓冲区，并处理 WebSocket 的底层握手
                                await sleep(10);

                                // 如果包非常多（比如超过 500 包），可以适当增加休眠时间
                                if (j > 0 && j % 100 === 0) {
                                    await sleep(50);
                                }
                            }
                            console.log(`文件分 ${partCount} 次发送完毕`);
                        } else {
                            // 小文件一次性发送
                            res[i].fileCount = 1;
                            webSocketPrint.doPrint("9999", JSON.stringify(res[i]));
                            await sleep(10); // 即使是单包，也建议微小延迟，保护后续任务
                        }
                    }
                }
            },
            appendCartonEvent(){
                let params = {
                    sscc: this.cartonInfo.sscc
                };
                ajax.get(api.PICKTOZEROCARTONAPPEND, params).then(res => {
                    if (res.code == 200) {
                        this.$message.success(res.msg,3)
                        this.searchOrderByInfo();
                    }else {
                        this.$customMessage.error(res.msg,3);
                    }
                });
            },
            removeCartonEvent(){
                let params = {
                    sscc: this.cartonInfo.sscc
                };
                ajax.get(api.PICKTOZEROCARTONREMOVE, params).then(res => {
                    if (res.code == 200) {
                        this.initCartonInfo();
                        this.searchOrderByInfo();
                        this.$message.success(res.msg,3)
                    }else {
                        this.$customMessage.error(res.msg,3);
                    }
                });
            },
            saveCartonEvent(){
                ajax.post(api.PICKTOZEROCARTONSAVE, this.cartonInfo).then(res => {
                    if (res.code == 200) {
                        // this.soOrderTable = res.data;
                        // this.focusEvent();
                        this.$message.success(res.msg,3)
                    }else {
                        this.$customMessage.error(res.msg,3);
                    }
                });
            },
            cartonTypeChange(val){
                let cartonTypeList =  this.systemParam.CARTON_MASTER_LIST;
                let newCartypeCbmJs = this.systemParam.CBM;
                cartonTypeList.forEach((item, index) => {
                    if(item.cartonType == val){
                        this.cartonInfo.length = item.length;
                        this.cartonInfo.width = item.width;
                        this.cartonInfo.height = item.height;
                        this.cartonInfo.dimensionUom = item.dimensionUom;
                        this.cartonInfo.weightUom = item.weightUom;

                        let uom = 1;
                        if(this.cartonInfo.dimensionUom == null){
                            uom=1;
                        }else if(this.cartonInfo.dimensionUom == 'm' || this.cartonInfo.dimensionUom == 'M'){
                            uom=1;
                        }else if(this.cartonInfo.dimensionUom == 'dm' || this.cartonInfo.dimensionUom == 'DM'){
                            uom=10;
                        }else if(this.cartonInfo.dimensionUom == 'cm' || this.cartonInfo.dimensionUom == 'CM'){
                            uom=100;
                        }
                        let cbm = (this.cartonInfo.length / uom)*(this.cartonInfo.width / uom)*(this.cartonInfo.height / uom);

                        if(newCartypeCbmJs == null){
                            this.cartonInfo.cbm = cbm;
                        }else{
                            this.cartonInfo.cbm = this.pub_decimaltoFixed(cbm,newCartypeCbmJs);
                        }
                    }
                })

            },
            scanpackTabsEvent(val){


                if (val == 1){



                   if(this.searchConditionModelisEmpty()) {
                       return;
                   }
                    this.pdAllocatedQty = 0;
                    this.pdPackedQty = 0;
                    this.pdPercentage = 0;
                    this.pdNoOfCarton = 0;


                   for (let i  in this.soOrderTable) {
                       let row = this.soOrderTable[i];
                       this.pdAllocatedQty += row.allBaseQty;
                       this.pdPackedQty += row.packedBaseQty;
                       this.pdPercentage = Math.round((this.pdPackedQty / this.pdAllocatedQty) * 10000) / 100.0 + "%";
                   }



                    ajax.post(api.SCANPICKTOZEROPACKDETAIL, this.searchConditionModel).then(res => {
                        this.packDetailTable = res.data
                        let  ssccArray = [];
                        for (let i  in  this.packDetailTable) {
                           let row = this.packDetailTable[i];
                            if (ssccArray.indexOf(row.sscc) < 0){
                                ssccArray.push(row.sscc)
                            }
                        }
                        this.pdNoOfCarton = ssccArray.length;
                    })
                }
            },
            cancelPackByPoClick(){
               let ref01 = this.searchConditionModel.ref01;
               if (ref01 == null || ref01.length < 1){
                  let displayName = this.fieldMap.tlRef01.displayName;
                   this.$customMessage.error(displayName+" "+ this.$t('job.notNull'),3);
               }
                ajax.post(api.PICKTOZEROCANCELPACKBYPO, this.searchConditionModel).then(res => {
                    if (res.code == 200) {
                        this.initCartonInfo();
                        this.searchOrderByInfo();
                        this.$message.success(res.msg,3)
                    }else {
                        this.$customMessage.error(res.msg,3);
                    }
                })
            },
            cancelPackBySoClick(){
                let relId = this.searchConditionModel.relId;
                if (relId == null || relId.length < 1){
                    let displayName = this.fieldMap.tlRelId.displayName;
                    this.$customMessage.error(displayName+" "+ this.$t('job.notNull'),3);
                    return;
                }
                ajax.post(api.PICKTOZEROCANCELPACKBYSO, this.searchConditionModel).then(res => {
                    if (res.code == 200) {
                        this.initCartonInfo();
                        this.searchOrderByInfo();
                        this.$message.success(res.msg,3)
                    }else {
                        this.$customMessage.error(res.msg,3);
                    }
                })
            },
            cancelPackByLineClick(){
                const checkedRows = this.$refs.skuTable.getCheckboxRecords();
                let array = [];
                for (let index in checkedRows){
                  let  row =  checkedRows[index]
                  if (row.sscc == '*'){
                      this.$customMessage.error( this.$i18n.t('pubGicSet.unscanpackDataNotCancel'),3);
                      return
                  }
                  let obj = {sku:row.sku,
                    sscc:row.sscc,
                     relId: row.relId
                  }
                    array.push(obj)
                }
                if (array.length == 0){
                    this.$customMessage.error( this.$i18n.t('publicLang.PleaseOneLeast'),3);
                    return
                }
                ajax.post(api.PICKTOZEROCANCELPACKBYLINE, {cancelPackItems:array}).then(res => {
                    if (res.code == 200) {
                        this.initCartonInfo();
                        this.searchOrderByInfo();
                        this.$message.success(res.msg,3)
                    }else {
                        this.$customMessage.error(res.msg,3);
                    }
                })

            },
            batchCloseCartonClick(){
                if (this.skuItemsBySscc.length > 0){
                   let errorMsg = this.$t('scanPack.notAllowedBatchClose');
                    this.$customMessage.error( errorMsg,3);
                    return;
                }
                ajax.post(api.PICKTOZEROBATCHCLOSECARTON, this.searchConditionModel).then(res => {
                    if (res.code == 200) {
                        this.$message.success(res.msg,3)
                        this.initCartonInfo();
                        this.searchOrderByInfo();
                        this.closeCartonAutoPrint(res.data)
                    }else {
                        this.$customMessage.error(res.msg,3);
                    }
                })
            },
            checkCompleteClick(){
                //判断是否为部分完成
                let existNotScanPackData =false;
                for (let index in  this.soOrderTable){
                    let row = this.soOrderTable[index]
                    let sscc = row.sscc
                    if (sscc == '*'){
                        existNotScanPackData = true;
                        break;
                    }
                }
                if(existNotScanPackData){
                    let that=this;
                    this.$customConfirm({
                        title:  that.$t('scanPack.partialPack'),
                        okText: that.$t('scanPack.cancelCheckCompleteYes'),
                        cancelText: that.$t('scanPack.cancelCheckCompleteNo'),
                        content: "",
                        onOk() {
                            ajax.post(api.PICKTOZEROCHECKCOMPLETE, that.searchConditionModel).then(res => {
                                if (res.code == 200) {
                                    that.initCartonInfo();
                                    that.searchOrderByInfo();
                                    that.$message.success(res.msg,3)
                                }else {
                                    that.$customMessage.error(res.msg,3);
                                }
                            })
                        },
                        onCancel() {}
                    });
                }else{
                    ajax.post(api.PICKTOZEROCHECKCOMPLETE, this.searchConditionModel).then(res => {
                        if (res.code == 200) {
                            this.initCartonInfo();
                            if(res.data) {
                                // next relId
                                this.searchConditionModel.relId = res.data;
                            }
                            this.searchOrderByInfo();
                            this.$message.success(res.msg,3)
                        }else {
                            this.$customMessage.error(res.msg,3);
                        }
                    })
                }



            },
            searchConditionModelisEmpty(){
              if (this.searchConditionModel == null || (
                  (this.searchConditionModel.relId == null || this.searchConditionModel.relId.trim() == ''  ) &&
                  (this.searchConditionModel.ref01 == null || this.searchConditionModel.ref01.trim() == ''  )  &&
                  (this.searchConditionModel.ref02 == null || this.searchConditionModel.ref02.trim() == ''  )  &&
                  (this.searchConditionModel.ref03 == null || this.searchConditionModel.ref03.trim() == ''  )  &&
                  (this.searchConditionModel.ref04 == null || this.searchConditionModel.ref04.trim() == ''  )
              )){
                  return true;
              }
            },
            cancelCheckCompleteClick(){
                ajax.post(api.PICKTOZEROCANCELCHECKCOMPLETE, this.searchConditionModel).then(res => {
                    if (res.code == 200) {
                        this.initCartonInfo();
                        this.searchOrderByInfo();
                        this.$message.success(res.msg,3)
                    }else {
                        this.$customMessage.error(res.msg,3);
                    }
                })
            },
            closeOrderClick(){
                ajax.post(api.PICKTOZEROCLOSE, this.searchConditionModel).then(res => {
                    if (res.code == 200) {
                        this.initCartonInfo();
                        this.searchOrderByInfo();
                        this.$message.success(res.msg,3)
                    }else {
                        this.$customMessage.error(res.msg,3);
                    }
                })
            },
            initCartonInfo(){
                this.cartonInfo = {
                    uid: "",
                    sscc: "",
                    cartonNo: "",
                    cartonType: null,
                    logisticsid:"",
                    length: "",
                    width: "",
                    height: "",
                    dimensionUom: "",
                    cbm: "",
                    grossWeight: "",
                    weightUom: "",
                    userdefined1: "",
                    userdefined2: "",
                    userdefined3: "",
                    userdefined4: "",
                    userdefined5: ""
                }
                this.cartonQty = null;
                this.lockScCartonQty = false;
                this.lockScSscc = false;
                this.cartonTable = [];
                this.sumCartonPackQty = 0;
                this.sumCartonSku = 0;
                this.skuItemsBySscc=[];
            },
            init(){
                this.searchConditionModel = {
                        ref01: "",
                        relId: "",
                        sku: "",
                        ref02: "",
                        ref03: "",
                        ref04: "",
                        soUid: "",
                };
                this.scanpackTabsTarget = '2',
                this.lockScSscc= false,
                this.sumUnpackQty = 0;
                this.sumPackedQty = 0;
                this.soOrderTable =  [];
                this.isAlertError= false;
                this.scanErrorMsg = "";
                this.scSku =  "";
                this.lockScQty  = true;
                this.lockScRemoveScanItem  = false;
                this.cartonInfo = {
                        uid: "",
                        sscc: "",
                        cartonNo: "",
                        cartonType: null,
                        logisticsid:"",
                        length: "",
                        width: "",
                        height: "",
                        dimensionUom: "",
                        cbm: "",
                        grossWeight: "",
                        weightUom: "",
                        userdefined1: "",
                        userdefined2: "",
                        userdefined3: "",
                        userdefined4: "",
                        userdefined5: ""
                }
                this.packDetailTable = [];
                this.pdPackedQty = 0;
                this.pdPercentage = 0;
                this.pdNoOfCarton = 0;
                this.pdAllocatedQty = 0;
                this.isAllowOverScan= false;
                this.isHiddenTable = false;

            },
            scQtyEnterEvent(){
                if (! (typeof this.scQty === 'number' && !isNaN(this.scQty))){
                    this.$refs.scQty.focus();
                    this.scanErrorMusic();
                    this.scanErrorMsg =this.$t('pubGicSet.QuantityTypeError');
                    this.isAlertError = true;
                    return;
                }

                this.scanSkuEvent(true);
            },
            cancelAlertError(){
                this.scanErrorMusic();
                this.isAlertError = false;
            },
            scanErrorMusic() {
                let audio = document.getElementById("scanErrorMusic");
                if (audio !== null) {
                    if (audio.paused) {
                        audio.play();
                    } else {
                        audio.pause();
                    }
                }
            },
            scSkuEnterEvent(){
                this.scanSkuEvent(false);
            },
            scanSkuEvent(isScQtyEnter){
               let isSuccessFocus =  this.focusEvent(isScQtyEnter);
               // console.info("99999")
               //  console.info(isSuccessFocus)
               if (isSuccessFocus){return;}
                let unpackBaseQtyBySku =  null ;
                let packedBaseQtyBySku =  null ;

                for (let index in this.soOrderTable) {
                   let row = this.soOrderTable[index];

                   if ( row.sku == this.scSku ){
                       if (unpackBaseQtyBySku == null ){
                           unpackBaseQtyBySku = 0;
                       }
                       if (packedBaseQtyBySku == null){
                           packedBaseQtyBySku = 0;
                       }
                       if (this.cartonInfo.sscc != '' && row.sscc == this.cartonInfo.sscc){
                           packedBaseQtyBySku += row.packedBaseQty;
                       }
                       unpackBaseQtyBySku += row.unpackedBaseQty;
                   }
                }


                if (unpackBaseQtyBySku == null){
                    this.$refs.scSku.select()
                    this.scanErrorMusic();
                    this.scanErrorMsg =  this.$i18n.t('pubGicSet.InvalidSKU',{"0":this.scSku})
                    this.isAlertError = true;
                    return;
                }


                if ( ( (!this.lockScRemoveScanItem) &&  this.scQty > unpackBaseQtyBySku &&(!  this.isAllowOverScan) )  || (this.lockScRemoveScanItem && this.scQty > packedBaseQtyBySku  ) ){
                    if (this.lockScQty){
                        this.$refs.scSku.select()
                    }else {
                        const inputElement = this.$refs.scQty.$el.querySelector('input');
                        if (inputElement) {
                            inputElement.select();  // 选中内容
                        }
                    }
                    let errMsgKey = "";

                    if (! this.lockScRemoveScanItem  ){
                            errMsgKey = 'pubGicSet.NotEnoughQtyPack';
                    }else {
                        errMsgKey = 'pubGicSet.NotEnoughQtyCancelPack';
                    }
                    this.scanErrorMusic();
                    this.scanErrorMsg =  this.$i18n.t(errMsgKey,{"0":this.scSku})
                    this.isAlertError = true;
                    return;
                }

                if (this.cartonInfo.sscc == '' ){
                    let params = {};
                    this.lockScSku = true;
                    this.cartonTable= [];
                    this.initCartonInfo();
                    ajax.post(api.SAVECARTON, params).then(res => {
                        if (res.code == 200) {
                            let packCarton = res.data;
                            for (let key in packCarton) {
                                if (this.cartonInfo.hasOwnProperty(key)) {
                                    this.cartonInfo[key] = packCarton[key];
                                }
                            }
                            let uom = 1;
                            if(this.cartonInfo.dimensionUom == null){
                                uom=1;
                            }else if(this.cartonInfo.dimensionUom == 'm' || this.cartonInfo.dimensionUom == 'M'){
                                uom=1;
                            }else if(this.cartonInfo.dimensionUom == 'dm' || this.cartonInfo.dimensionUom == 'DM'){
                                uom=10;
                            }else if(this.cartonInfo.dimensionUom == 'cm' || this.cartonInfo.dimensionUom == 'CM'){
                                uom=100;
                            }
                            let cbm = (this.cartonInfo.length / uom)*(this.cartonInfo.width / uom)*(this.cartonInfo.height / uom);
                            let newCartypeCbmJs = this.systemParam.CBM
                            if(newCartypeCbmJs == null){
                                this.cartonInfo.cbm = cbm;
                            }else{
                                this.cartonInfo.cbm = this.pub_decimaltoFixed(cbm,newCartypeCbmJs);
                            }
                            this.lockScSku = false;
                            if (this.systemParam.scanpack_way == 'Y'){
                                this.scanSkuByCache();    // 缓存扫描
                            }else {
                                this.scanSkuByRealTime(); // 实时扫描
                            }

                        }else {
                            this.lockScSku = false;
                            this.$refs.scSku.select()
                            this.scanErrorMusic();
                            this.scanErrorMsg =  res.msg;
                            this.isAlertError = true;
                            return;
                        }
                    });
                }else {
                    if (this.systemParam.scanpack_way == 'Y'){
                        this.scanSkuByCache();     // 缓存扫描
                    }else {
                        this.scanSkuByRealTime();  // 实时扫描
                    }
                }
            },

            async  scanSkuByRealTime(){
                let params = {};
                params.remove = this.lockScRemoveScanItem;
                params.allowOverScan = this.isAllowOverScan;
                params.scSku= this.scSku;
                params.scanQty = this.scQty;
                params.sscc = this.cartonInfo.sscc
                params.searchCondition=this.searchConditionModel;
                params.cartonInfo = this.cartonInfo;
                params.relId = this.cartonInfo.relId;

                // params.car =  this.cartonInfo.uid
                ajax.post(api.SCANPICKTOZEROSKU, params).then(async res => {
                    if (res.code == 200) {
                        this.scSku="";
                        this.lockScSscc = true;
                        if (this.cartonInfo.uid != null && this.cartonInfo.uid.trim() != '' &&  params.remove  && res.data.cartonUid == ''){
                            this.initCartonInfo();
                        }

                        let  currentScanQty = this.lockScRemoveScanItem ? -params.scanQty : params.scanQty;
                        if (! this.isHiddenTable ){
                            this.searchOrderByInfo().then(() => {
                                this.computeCartonTable(params.scSku,currentScanQty)
                            }).catch(error => {
                                console.error('error :', error);
                            });
                       }else {
                          let relId = res.data.relId;
                          let rowBySSCC_index = -1;
                          let rowByRelId_index = -1;
                          for(let index in this.soOrderTable){
                              let row = this.soOrderTable[index];
                              if(row.relId == relId && row.sku  == params.scSku){
                                  if ( row.sscc == params.sscc ){
                                      rowBySSCC_index = index;
                                  }else if (row.sscc == '*'){
                                      rowByRelId_index = index;
                                  }
                              }
                          }

                          if (rowBySSCC_index < 0 && rowByRelId_index < 0 ){
                              this.searchOrderByInfo().then(() => {
                                  this.computeCartonTable(params.scSku,currentScanQty)
                              }).catch(error => {
                                  console.error('error :', error);
                              });
                          }else {
                              let  clonedSoOrderTab = JSON.parse(JSON.stringify(this.soOrderTable));
                              let isChangOrigalData = true;


                              // console.info("999888")
                              if (rowBySSCC_index > 0) {
                                 let rowBySSCC = clonedSoOrderTab[rowBySSCC_index];
                                  rowBySSCC.allBaseQty =  rowBySSCC.allBaseQty + currentScanQty;
                                  rowBySSCC.packedBaseQty =  rowBySSCC.packedBaseQty + currentScanQty;
                              }else {
                                  if (this.lockScRemoveScanItem){
                                      isChangOrigalData = false;
                                      this.searchOrderByInfo().then(() => {
                                          this.computeCartonTable(params.scSku,currentScanQty)
                                      }).catch(error => {
                                          console.error('error :', error);
                                      });
                                  }else {
                                      let  clonedRowByRelId = JSON.parse(JSON.stringify(clonedSoOrderTab[rowByRelId_index]));
                                      clonedRowByRelId.allBaseQty = params.scanQty;
                                      clonedRowByRelId.unpackedBaseQty =0 ;
                                      clonedRowByRelId.packedBaseQty = params.scanQty;
                                      clonedRowByRelId.sscc = params.sscc;
                                      clonedSoOrderTab.push(clonedRowByRelId);
                                  }
                              }

                            if (isChangOrigalData){
                                this.computeCartonTable(params.scSku,currentScanQty)

                                let rowByRelId =  clonedSoOrderTab[rowByRelId_index];
                                if (rowByRelId_index  == -1 && rowBySSCC_index > -1 ){
                                    let rowBySSCC = clonedSoOrderTab[rowBySSCC_index];
                                    let  clonedRowBySscc = JSON.parse(JSON.stringify(rowBySSCC));
                                    clonedRowBySscc.allBaseQty = params.scanQty;
                                    clonedRowBySscc.unpackedBaseQty =params.scanQty ;
                                    clonedRowBySscc.packedBaseQty =0 ;
                                    clonedRowBySscc.sscc = '*';


                                    let indexByRelId = -1;
                                    let indexByXing = -1;
                                    for (let i in clonedSoOrderTab){
                                      let row =  clonedSoOrderTab[i]

                                        if (row.sscc == '*' && row.relId == relId ){
                                            if (indexByRelId == -1 || row.unpackedBaseQty  > params.scanQty){
                                                indexByRelId = i;
                                            }
                                        }else if (row.sscc == '*' ){
                                            indexByXing = i;
                                        }
                                    }

                                    if (indexByRelId > -1){
                                        clonedSoOrderTab.splice(indexByRelId+1, 0,clonedRowBySscc);
                                    }else if (indexByXing > -1){
                                        clonedSoOrderTab.splice(indexByXing+1, 0,clonedRowBySscc);
                                    }else {
                                        clonedSoOrderTab.push(clonedRowBySscc);
                                    }
                                }else {
                                    rowByRelId.allBaseQty =rowByRelId.allBaseQty - currentScanQty;
                                    rowByRelId.unpackedBaseQty = rowByRelId.unpackedBaseQty - currentScanQty ;
                                    if (rowByRelId.unpackedBaseQty == 0){
                                        clonedSoOrderTab.splice(rowByRelId_index, 1); // 删除该行
                                    }
                                   let row = clonedSoOrderTab[rowBySSCC_index];
                                    if ( row != null  && row.packedBaseQty == 0){
                                        clonedSoOrderTab.splice(rowBySSCC_index, 1);
                                    }

                                }
                                this.soOrderTable = clonedSoOrderTab;

                                this.btnControll();
                            }
                          }
                       }
                        // this.$message.success(res.msg, 3);
                        this.$refs.scanSuccessMusicRef.play();
                        if (this.lockScRemoveScanItem){
                            this.lockScRemoveScanItem = false;
                        }
                    }else {
                        this.$refs.scSku.select();
                        this.scanErrorMusic();
                        this.scanErrorMsg =  res.msg;
                        this.isAlertError = true;
                        return;
                    }
                });
            },
            scanSkuByCache(){

                let matchingRow = null; // 匹配soOrderTable中的数据
                let matchingRowIndex = -1;
                let isRemove = this.lockScRemoveScanItem;
                let scSku = this.scSku;
                let scQty =  this.scQty;
                let relId =  null;
                let otherOrderBySku = null;
                let isAllowOverScan = this.isAllowOverScan;
                let  clonedSoOrderTab = JSON.parse(JSON.stringify(this.soOrderTable));

                for (let index in clonedSoOrderTab){
                    let row = clonedSoOrderTab[index];
                    if (this.cartonInfo.sscc != '' && row.sscc == this.cartonInfo.sscc){
                        if (row.cartonStatus == 'Y') {
                            this.$refs.scSku.select();
                            this.scanErrorMusic();
                            this.scanErrorMsg =   this.$t('pubGicSet.CartonClose',{"0":this.cartonInfo.sscc});
                            this.isAlertError = true;
                            return;
                        }
                        relId = row.relId;
                        break;
                    }
                }

                let existRelIdAndSkuAndSsccSameData = false;

                for (let index in clonedSoOrderTab) {
                    let row = clonedSoOrderTab[index];
                    if ( row.sku == scSku ){
                        if (isRemove ){
                            if (row.relId == relId  && this.cartonInfo.sscc != '' && row.sscc == this.cartonInfo.sscc && row.packedBaseQty >= scQty ){
                                matchingRowIndex = index;
                                matchingRow = row;
                                break;
                            }
                        }else {
                            if (row.sscc == '*'){
                                if (relId == null || row.relId == relId){
                                    if (row.unpackedBaseQty >= scQty || this.isAllowOverScan ){
                                        matchingRowIndex = index;
                                        matchingRow = row;
                                        break;
                                    }
                                }else if (otherOrderBySku == null){// SKU exist other order
                                    otherOrderBySku = row;
                                }
                            }else if ( row.relId == relId && row.sscc == this.cartonInfo.sscc){
                                existRelIdAndSkuAndSsccSameData = true;
                            }
                        }
                    }
                }

                if (isAllowOverScan && (!isRemove) &&  matchingRow == null){
                    let rowByOtherSscc = null;
                    for (let index in clonedSoOrderTab) {
                        let row = clonedSoOrderTab[index];
                        if (row.sku == scSku && row.relId == relId ){
                            if (this.cartonInfo.sscc != '' && row.sscc == this.cartonInfo.sscc){
                                matchingRowIndex = index;
                                matchingRow = row;
                                break;
                            }else  if (rowByOtherSscc == null){
                               rowByOtherSscc = row;
                            }
                        }
                    }
                    if (matchingRow == null && rowByOtherSscc != null){
                        matchingRow = JSON.parse(JSON.stringify(rowByOtherSscc)); ;
                        matchingRow.unpackedBaseQty = scQty;
                        matchingRow.sscc = '*';
                        matchingRow.cartonStatus='N';
                        matchingRow.allBaseQty = scQty;
                    }
                }

                if (matchingRow == null){
                    let errMsgKey;
                    let errParams;
                    if (isRemove){
                        errMsgKey = 'pubGicSet.NotEnoughQtyCancelPack';
                        errParams = this.scSku;
                    }else {
                        if (existRelIdAndSkuAndSsccSameData || otherOrderBySku == null){
                            errMsgKey = 'pubGicSet.NotEnoughQtyPack';
                            errParams = this.scSku;
                        }else {
                            errMsgKey = 'scanPack.ssccAlreadyUse';
                            errParams = this.cartonInfo.sscc;
                        }
                    }
                    this.$refs.scSku.select();
                    this.scanErrorMusic();
                    this.scanErrorMsg =  this.$t(errMsgKey,{"0":errParams})
                    this.isAlertError = true;
                    return;
                }


                if ( isRemove ){
                    matchingRow.packedBaseQty  -=  this.scQty;
                    matchingRow.allBaseQty -= this.scQty;

                    let matchingRowBySSCC = null;
                    for (let index in clonedSoOrderTab) {
                        let row = clonedSoOrderTab[index];
                        if (row.sku == scSku && row.relId == matchingRow.relId &&  row.sscc == '*'){
                            matchingRowBySSCC = row;
                            break;
                        }
                    }

                    if (matchingRowBySSCC == null){
                        let  matchingRowBySSCC = JSON.parse(JSON.stringify(matchingRow));
                        matchingRowBySSCC.sscc = '*';
                        matchingRowBySSCC.packedBaseQty = 0;
                        matchingRowBySSCC.unpackedBaseQty = scQty;
                        matchingRowBySSCC.allBaseQty = scQty;
                        matchingRowBySSCC.notSubmit= true;
                        let indexByOtherRelId = -1;
                        let indexByRelId = -1;
                        for (let i in clonedSoOrderTab) {
                            let row = clonedSoOrderTab[i];
                            if (row.sscc == '*'){
                                indexByOtherRelId = parseInt(i)+1;
                                if (row.relId == matchingRow.relId ){
                                    indexByRelId = parseInt(i)+1;
                                }
                            }
                        }
                        let index = 0;
                        if (indexByRelId > -1){
                            index = indexByRelId;
                        }else if (indexByOtherRelId > -1){
                            index = indexByOtherRelId;
                        }
                        clonedSoOrderTab.splice(index,0,matchingRowBySSCC);
                    }else {
                        matchingRowBySSCC.unpackedBaseQty += scQty;
                        matchingRowBySSCC.allBaseQty += scQty;
                    }
                    if (matchingRow.packedBaseQty == 0){
                        clonedSoOrderTab.splice(matchingRowIndex, 1);
                    }
                }else {

                    let matchingRowBySSCC = null;
                    let matchingRowBySSCCIndex = -1;
                    for (let index in clonedSoOrderTab) {
                        let row = clonedSoOrderTab[index];
                        if (row.sku == scSku && row.relId == matchingRow.relId && this.cartonInfo.sscc == row.sscc){
                            matchingRowBySSCC = row;
                            matchingRowBySSCCIndex = index
                            break;
                        }
                    }

                    if (matchingRowBySSCCIndex != matchingRowIndex){
                        matchingRow.allBaseQty  -=  this.scQty;
                        matchingRow.unpackedBaseQty -= this.scQty;
                    }

                    if (matchingRowBySSCC == null){
                        let  matchingRowBySSCC = JSON.parse(JSON.stringify(matchingRow));
                        matchingRowBySSCC.sscc = this.cartonInfo.sscc;
                        matchingRowBySSCC.packedBaseQty = scQty;
                        matchingRowBySSCC.allBaseQty = scQty;
                        matchingRowBySSCC.unpackedBaseQty = 0;
                        matchingRowBySSCC.notSubmit= true;
                        clonedSoOrderTab.push(matchingRowBySSCC);
                    }else {
                        matchingRowBySSCC.packedBaseQty += scQty;
                        matchingRowBySSCC.allBaseQty += scQty;
                    }
                    if (matchingRow.unpackedBaseQty <= 0 &&  matchingRow.sscc == '*'){
                        clonedSoOrderTab.splice(matchingRowIndex, 1);
                    }
                }

                let skuItemIndex =  -1;
                for(let index in this.skuItemsBySscc){
                    let row = this.skuItemsBySscc[index];
                    if(! row.allowOverScan){
                        row.allowOverScan = isAllowOverScan;
                    }
                    if (row.scSku == scSku && row.relId == matchingRow.relId && this.cartonInfo.sscc == row.sscc){
                        skuItemIndex = parseInt(index);
                        if (row.remove){
                            if (isRemove) {
                                row.scanQty += scQty;
                            }else {
                                if ( row.scanQty >= scQty){
                                    row.scanQty -= scQty;
                                }else {
                                    row.remove = false;
                                    row.scanQty = scQty - row.scanQty;
                                }
                            }
                        }else {
                            if (isRemove){
                                if (row.scanQty >= scQty){
                                    row.scanQty -= scQty;
                                }else {
                                    row.remove = false;
                                    row.scanQty = scQty - row.scanQty;
                                }
                            }else {
                                row.scanQty += scQty;
                            }
                        }
                    }
                    if (row.scanQty == 0){
                        this.skuItemsBySscc.splice(index, 1);
                    }
                }

                if (skuItemIndex < 0){
                    let skuIntem = {
                        scanQty: scQty,
                        scSku: scSku,
                        remove: isRemove,
                        relId: matchingRow.relId,
                        allowOverScan: isAllowOverScan,
                        sscc: this.cartonInfo.sscc
                    }
                    this.skuItemsBySscc.push(skuIntem);
                }
                this.soOrderTable = clonedSoOrderTab;

                this.computeCartonTable(scSku,isRemove ? -scQty : scQty);

                this.scSku="";
                this.lockScSscc = true;
                this.$refs.scanSuccessMusicRef.play();
                if (this.lockScRemoveScanItem){
                    this.lockScRemoveScanItem = false;
                }
                if (this.cartonInfo.uid == null || this.cartonInfo.uid == ''){
                    this.cartonInfo.uid="-1";
                }

                this.$nextTick(()=> {
                    this.focusEvent();
                })

            },

            computeCartonTable(sku,qty){
                this.cartonTableSKU = sku;
                if (this.systemParam.scanpack_way != 'Y' && this.cartonInfo.uid == null || this.cartonInfo.uid == ''){
                    this.cartonSearchEnter();
                    return;
                }
                let matching = false;
               if (this.cartonTable  != null && this.cartonTable.length > 0){
                   for (let index  in  this.cartonTable ) {
                       let row = this.cartonTable[index]
                       if (row.sku == sku){
                           row.scannedQty += qty;
                           if (row.scannedQty == 0){
                               this.cartonTable.splice(index, 1);
                           }
                           matching = true;
                       }
                   }
               }

              if (! matching) {
                  if (this.cartonInfo !=  null && this.cartonInfo.sscc != null && this.cartonInfo.sscc != '' ){
                      let rowByCarton = null;
                      for (let index  in  this.soOrderTable ) {
                          let row = this.soOrderTable[index]
                          if (row.sscc == this.cartonInfo.sscc && row.sku == sku){
                              rowByCarton= {
                                  sku :  row.sku,
                                  descr : row.descr,
                                  uom : 'EA',
                                  scannedQty : qty
                              };
                              break;
                          }
                      }
                      if (rowByCarton != null){
                          if (this.cartonTable == null){
                              this.cartonTable = [];
                          }
                          this.cartonTable.unshift(rowByCarton);
                      }
                  }
              }
                this.computeSumCartonInfo();
            },
            pub_decimaltoFixed(params,num) {
                let newpar = parseFloat(params);
                let reg = /^[0-9]+.?[0-9]*$/;
                if(reg.test(newpar)){
                    let newNum = newpar.toFixed(num);
                    return newNum
                }else{
                    return
                }
            },
            lockScRemoveScanItemEvent(){
                this.lockScRemoveScanItem = ! this.lockScRemoveScanItem;
            },
            lockScQtyEvent(){
                this.lockScQty = ! this.lockScQty;
                if(! this.lockScQty){
                    // this.scQty = null
                    this.focusEvent();
                }else {
                    if (this.scQty == null || this.scQty ==  0 || this.scQty == '' ){
                        this.scQty = 1
                    }
                }
            },
            focusEvent(isScQtyEnter){
                // return new Promise((resolve, reject) => {
                //
                // });
                let isSuccessFocus = false;
                if (this.searchConditionModelisEmpty()){
                    this.$nextTick(()=> {
                        isSuccessFocus = true;
                        this.$refs.tlRef01.focus();
                    })
                }else if (this.scSku == null ||  this.scSku.trim() == ''){
                    // this.$nextTick(()=> {
                    //     console.info("666")
                         isSuccessFocus = true;
                         this.$refs.scSku.focus();
                    // })
                }else if (this.scQty == 0  || this.scQty == null || this.scQty == '' || ((!this.lockScQty)&&(!isScQtyEnter)) ){
                    // this.$nextTick(()=> {
                    // console.info("7777")
                        isSuccessFocus = true;
                        this.$refs.scQty.focus();
                    // })
                }
                return isSuccessFocus;
            },

            searchOrderByInfo(type){
                // let  that = this;
                return new Promise((resolve, reject) => {
                    ajax.post(api.SEARCHSOORDERBYINFO, this.searchConditionModel).then(res => {
                        if (res.code == 200) {
                            this.soOrderTable = res.data;
                            if(this.searchConditionModel.soUid != null && this.searchConditionModel.soUid != '' && this.soOrderTable.length > 0 ){
                                this.searchConditionModel.relId = this.soOrderTable[0].relId;
                                this.searchConditionModel.soUid='';
                            }
                            this.btnControll();
                            this.focusEvent();
                            resolve(res); // 请求成功，调用 resolve
                        } else {
                            this.$customMessage.error(res.msg, 3);
                            if ('titleSearch' == type){
                                this.soOrderTable = [];
                                this.initCartonInfo();
                            }
                            reject(res.msg); // 请求失败，调用 reject
                        }
                    }).catch(error => {
                        this.$customMessage.error("Request error.", 3);
                        reject(error); // 请求出错，调用 reject
                    });
                });


                // ajax.post(api.SEARCHSOORDERBYINFO, this.searchConditionModel).then(res => {
                //     if (res.code == 200) {
                //         this.soOrderTable = res.data;
                //         this.focusEvent();
                //     }else {
                //         this.$customMessage.error(res.msg,3);
                //     }
                // });
            },
            btnControll(){
                let existSSCC = false;
                let existNotCloseSSCC = false;
                let existNotCheckComplete = false;
                let existCheckComplete = false;
                let existNotScanPackData = false;
                let orderStatusArray = [];
                for (let index in  this.soOrderTable){
                    let row = this.soOrderTable[index]
                    let sscc = row.sscc
                    if(row.notSubmit){
                        if (sscc == '*'){
                            sscc = '-1';
                        }else {
                            sscc = '*';
                        }
                    }

                    if (sscc != '*'){
                        existSSCC = true;
                        if (row.cartonStatus == 'N'){
                            existNotCloseSSCC = true;
                        }
                        let checkCompleteStatus = row.checkCompleteStatus;
                        if (checkCompleteStatus == null || checkCompleteStatus == 'N'){
                            existNotCheckComplete = true;
                        }else if (checkCompleteStatus == 'Y'){
                            existCheckComplete = true;
                        }
                    }else {
                        existNotScanPackData = true;
                    }
                    if (row.status != null && orderStatusArray.indexOf(row.status) < 0 ){
                        orderStatusArray.push(row.status);
                    }
                }
                if (existNotScanPackData){
                    this.lockImportPacking = false;
                }else {
                    if (this.soOrderTable == null || this.soOrderTable.length == 0){
                        this.lockImportPacking = false;
                    }else {
                        this.lockImportPacking = true;
                    }
                }

                if (existSSCC){
                    this.lockCancelPackByLineBtn = false;
                    if (this.searchConditionModel.ref01 != null && this.searchConditionModel.ref01 != '' && (this.searchConditionModel.relId == null || this.searchConditionModel.relId =='' ) ){
                        this.lockCancelPackByPOBtn = false;
                    }else {
                        this.lockCancelPackByPOBtn = true;
                    }
                    if (this.searchConditionModel.relId != null && this.searchConditionModel.relId != ''){
                        this.lockCancelPackBySOBtn = false;
                    }else {
                        this.lockCancelPackBySOBtn = true;
                    }
                }else {
                    this.lockCancelPackByPOBtn = true;
                    this.lockCancelPackBySOBtn = true;
                    this.lockCancelPackByLineBtn = true;
                }
                if (existNotCloseSSCC){
                    this.lockBatchCloseCartonBtn = false;
                }else {
                    this.lockBatchCloseCartonBtn = true;
                }

                if(this.systemParam.WM_CHECKCOMPLETE_CHECK=='Y' && existNotCheckComplete){
                    this.lockCheckCompleteBtn = false;
                }else if (existNotCheckComplete && (! existNotScanPackData)){
                    this.lockCheckCompleteBtn = false;
                }else {
                    this.lockCheckCompleteBtn = true;
                }
                if (existCheckComplete){
                    if (orderStatusArray.length == 1 && orderStatusArray.indexOf('99') > -1 ){
                        this.lockCancelCheckCompleteBtn = true;
                    }else {
                        this.lockCancelCheckCompleteBtn = false;
                    }
                    this.lockCancelPackBySOBtn = true;
                    this.lockCancelPackByPOBtn = true;
                    this.lockCancelPackByLineBtn = true;
                }else {
                    this.lockCancelCheckCompleteBtn = true;
                }
                if (existCheckComplete && (!existNotCheckComplete) && (! existNotScanPackData)){
                    if (orderStatusArray.length == 1 && orderStatusArray.indexOf('99') > -1 ){
                        this.lockCloseOrderBtn = true;
                    }else {
                        this.lockCloseOrderBtn = false;
                    }

                }else {
                    this.lockCloseOrderBtn = true;
                }
            },
            colStyle (status) {
                if(status == 'N'){
                    return {
                        color: 'red'
                    }
                }
            },
            overScanColStyle (status) {
                if(status == 'Y'){
                    return {
                        color: 'red'
                    }
                }
            },
            cartonSearchEnter(){
                if (this.cartonInfo.sscc == null || this.cartonInfo.sscc.trim() == ''){
                        this.initCartonInfo();
                        return;
                }
                let params = {
                    sscc: this.cartonInfo.sscc
                };
                ajax.get(api.SEARCHPICKTOZEROCARTON, params).then(res => {
                    this.cartonTable = res.data == null ? []:res.data.packDetailListBySscc;
                    if ( res.data != null  &&   res.data.cartonInfo != null && res.data.cartonInfo.uid != null){
                        this.cartonInfo = res.data.cartonInfo;
                        this.cartonInfo.relId = res.data.relId;
                    }

                    if (this.cartonTable == null ){
                        this.cartonTable = [];
                    }
                   this.computeSumCartonInfo();

                })
                this.focusEvent();
            },
            computeSumCartonInfo(){
               this.sumCartonPackQty = 0;
               this.sumCartonSku = 0;
               let skuArray = [];
               if (this.cartonTable != null && this.cartonTable.length > 0){
                   for (let index in this.cartonTable){
                       let obj =this.cartonTable[index];
                       this.sumCartonPackQty += obj.scannedQty;
                       if (skuArray.indexOf(obj.sku) < 0){
                           skuArray.push(obj.sku);
                       }
                   }
                   this.sumCartonSku = skuArray.length;
               }
            },
            scanpackDetailTableEvnt({ row }){
                if(row == undefined || row == null ){
                    return;
                }

                this.cartonInfo.sscc = row.sscc;
                this.cartonSearchEnter();
                this.scanpackTabsTarget = '2'
            },
            cartonTableClass({ row }) {
                if(row.sku === this.cartonTableSKU){
                    return "col-orange";
                }
            },
            printByBtnConfig(btnConfig){
                // console.info(btnConfig)

                let requestParams =  {
                    gmcUid: btnConfig.gmcUid,
                    btnName: btnConfig.name,
                    btnUid: btnConfig.uid,
                    uid:""
                }

               if( this.searchConditionModel != null ){
                   for (let key in this.searchConditionModel){
                      let value = this.searchConditionModel[key];
                      if (value != null && value.trim() != ''){
                          requestParams[key] = value;
                      }
                   }
               }

                if (this.cartonInfo != null && this.cartonInfo.sscc != null && this.cartonInfo.sscc.trim() != ''){
                    requestParams.sscc = this.cartonInfo.sscc;
                }


               if ( requestParams.length < 4 ){
                   return;
               }


                //
                this.printPreview(requestParams)
            },
            printPreview(params){
                let ajaxurl = ajax.ajaxUrl();
                let that = this;
                this.isBtnajax = true
                axios.post(ajaxurl + api.PRINTPREVIEW, params, {
                    headers: {
                        Authorization: cookie.getBearerToken()
                    },
                    responseType: "blob" //二进制流
                }).then(function(res) {
                    let resHeader = res.headers;
                    let contentType = resHeader["content-type"];
                    let excelContentType = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8";
                    if(excelContentType.indexOf(contentType) !=-1) {
                        //excel
                        that.isBtnajax = false
                        var data  = res;
                        if (!data) {
                            return;
                        }
                        var blob = new Blob([data.data], {
                            type:
                                "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8"
                        });
                        var url = window.URL.createObjectURL(blob);
                        var aLink = document.createElement("a");
                        aLink.style.display = "none";
                        aLink.href = url;
                        aLink.setAttribute("download", "excel.xlsx");
                        document.body.appendChild(aLink);
                        aLink.click();
                        document.body.removeChild(aLink); //下载完成移除元素
                        window.URL.revokeObjectURL(url); //释放掉blob对象
                    } else {
                        //pdf
                        that.pubPdfMsgfn(res);
                    }
                });
            },
            pubPdfMsgfn(res){
                let data = res.data;
                let fileReader = new FileReader();
                let that = this
                fileReader.onload = function() {
                    try {
                        let jsonData = JSON.parse(this.result);
                        if (jsonData.code) {
                            that.$customMessage.warning(jsonData.msg);
                            that.$store.commit("updataLoading", { pbLoading: false });
                            that.isBtnajax = false
                        }
                    } catch (err) {
                        that.pubPdfUploadOk(res)
                    }
                };
                fileReader.readAsText(data)
            },
            //            pdf 成功下载方法
            pubPdfUploadOk(data){
                this.isBtnajax = false
                this.$store.commit("updataLoading", { pbLoading: false });
                let blob = new Blob([data.data], {type: "application/pdf;charset=utf-8"});
                let url = window.URL.createObjectURL(blob);
                window.open(url);
            },
            rowStyle ({ row }) {
                if(row.sscc == '*'){
                    return {
                        color: 'red'
                    }
                }else if(row.overScan == 'Y'){
                    return {
                        color: 'green'
                    }
                }
            },
            footerCellClassName ({ $rowIndex, column, columnIndex }) {
                return 'footerBackColor'
            },
            footerMethod({ columns, data }) {
                let that = this;
                return [
                    columns.map((column, columnIndex) => {
                        if (["allBaseQty", "packedBaseQty", "unpackedBaseQty",'sscc'].includes(column.property)) {
                            return that.sumPubFn(column.property);
                        }
                    })
                ];
            },
            sumPubFn(val) {
                let sum = 0;
                if (val == "allBaseQty" || val == "packedBaseQty" || val == "unpackedBaseQty"){
                    for (let index in this.soOrderTable) {
                        sum += parseInt(this.soOrderTable[index][val]);
                    }
                    if(val == "packedBaseQty"){
                        this.sumPackedQty = sum
                    }else if (val == "unpackedBaseQty"){
                        this.sumUnpackQty = sum
                    }
                }else if (val == "sscc"){
                    let ssccList = [];
                    for(let i in this.soOrderTable){
                      let sscc =  this.soOrderTable[i].sscc;
                        if( sscc != '*'){
                            if(ssccList.indexOf(sscc) == -1){
                                ssccList.push(sscc)
                            }
                        }
                    }
                    sum =  ssccList.length;
                }
                return sum;
            },
            cellClassName({ row }) {
                if (row === this.selectRow) {
                    return "col-orange";
                }
            },
            show(soUid) {
                let exportPermission = this.btnFunArr.find(item => item.code == 'Export');
                if (exportPermission) {
                    exportPermission.arr = [];
                }
                ajax.get(api.GENERICPRINTNODEALLBTNFORLOAD,{module_code:"SCAN_PACK_PICKTOZERO"}).then(res=>{
                    this.fieldMap = res.data.fieldMap;
                    let btnMap = res.data.behrMap;

                    if (btnMap != null ) {
                        // 遍历 Map，判断值是否为 null
                        for (let key in  btnMap) {
                            if (btnMap[key] !== null) {
                                for(let i in this.btnFunArr){
                                    if(this.btnFunArr[i].code == key){
                                        this.btnFunArr[i].arr = btnMap[key];
                                        // this.checkboxList.push(this.btnFunArr[i].code)
                                        // if (this.btnFunArr[i].code == 'ImportScanningFile') {
                                        //     this.importScanningFileDisab = true;
                                        // }
                                    }
                                }
                            }
                        }
                    }
                })


                if (soUid != null  ){
                    this.searchConditionModel.soUid = soUid
                    this.searchOrderByInfo();
                }
                this.lockImportPacking=false
                this.visible = true
                this.addListener();
                this.focusEvent();
            },


            closeScanPackPickToZero(){
                this.visible = false;
                this.init();
                this.initCartonInfo();
                this.scQty = 1;
            },

            /*===================================Slide to select start======================================================*/
            //表格单元格点击事件
            tableCellClick(e){
                let {row,column}=e;
                if(!this.isSelecting){
                    this.closeAreaBox();
                    this.selectionStart = this.getCellPosition(e.$event.target);
                    this.selectionEnd =this.selectionStart;
                    //设置样式
                    this.setselectedCellArea();
                }
            },
            //返回table的ref名称
            getTablexGrid(){
                return this.$refs.skuTable;
            },
            //添加事件
            addListener(){
                //添加多选列
                this.$nextTick(()=>{
                    this.closeAreaBox();

                    let tbody=this.getTablexGrid().$el.querySelector(".vxe-table--main-wrapper table tbody");
                    if(tbody){
                        tbody.addEventListener("mousedown",this.tbodymousedown);
                        tbody.addEventListener("mouseup",this.tbodymouseup);
                        tbody.addEventListener("mousemove",this.tbodymousemove);
                        tbody.addEventListener("paste",this.tbodykeydown);
                    }
                    let bodyWrapper=this.getTablexGrid().$el.querySelector(".vxe-table--main-wrapper .vxe-table--body-wrapper");
                    if(bodyWrapper){
                        //注意这里的ref名称，这里是非fixed区域的框的名称
                        bodyWrapper.appendChild(this.$refs.cellarea);
                    }

                    setTimeout(()=>{
                        let leftfixedtbody=this.getTablexGrid().$el.querySelector(".vxe-table--fixed-wrapper .vxe-table--fixed-left-wrapper table tbody");
                        if(leftfixedtbody){
                            leftfixedtbody.addEventListener("mousedown",this.tbodymousedown);
                            leftfixedtbody.addEventListener("mouseup",this.tbodymouseup);
                            leftfixedtbody.addEventListener("mousemove",this.tbodymousemove);
                            leftfixedtbody.addEventListener("paste",this.tbodykeydown);
                        }

                        let leftfixedBodyWrapper=this.getTablexGrid().$el.querySelector(".vxe-table--fixed-wrapper .vxe-table--fixed-left-wrapper .vxe-table--body-wrapper");
                        if(leftfixedBodyWrapper){
                            //注意这里的ref名称，这里是fixed区域的框的名称
                            leftfixedBodyWrapper.appendChild(this.$refs.fixedcellarea);
                        }
                    })


                    setTimeout(()=>{
                        let rightfixedtbody=this.getTablexGrid().$el.querySelector(".vxe-table--fixed-wrapper .vxe-table--fixed-right-wrapper table tbody");

                        if(rightfixedtbody){
                            rightfixedtbody.addEventListener("mousedown",this.tbodymousedown);
                            rightfixedtbody.addEventListener("mouseup",this.tbodymouseup);
                            rightfixedtbody.addEventListener("mousemove",this.tbodymousemove);
                            rightfixedtbody.addEventListener("paste",this.tbodykeydown);
                        }

                        let rightfixedBodyWrapper=this.getTablexGrid().$el.querySelector(".vxe-table--fixed-wrapper .vxe-table--fixed-right-wrapper .vxe-table--body-wrapper");
                        if(rightfixedBodyWrapper){
                            //注意这里的ref名称，这里是fixed区域的框的名称
                            rightfixedBodyWrapper.appendChild(this.$refs.rightfixedcellarea);
                        }
                    })
                })
            },
            //鼠标按下事件
            tbodymousedown(event){
                //左键
                if(event.button === 0){
                    this.closeAreaBox();
                    // 记录选择操作起始位置,
                    this.selectionStart = this.getCellPosition(event.target);
                    this.tempselectionStart = this.getCellPosition(event.target);
                    this.isSelecting = true;
                }
            },
            //鼠标移动事件
            tbodymousemove(event){
                //左键
                if(event.button === 0){
                    if (!this.isSelecting) return;
                    var x = event.clientX;
                    // 记录选择操作结束位置
                    this.selectionEnd = this.getCellPosition(event.target);
                    //设置样式
                    this.setselectedCellArea();
                    //持续向右滚动
                    var x = event.clientX;
                    var table=this.getTablexGrid().$el.querySelector(".vxe-table--body-wrapper table");
                    if(table){
                        let tableRect=table.parentElement.getBoundingClientRect();
                        if (x > tableRect.right - 20){
                            table.parentElement.scrollLeft+=20;
                        }
                    }
                }
            },
            //鼠标按键结束事件
            tbodymouseup(event) {
                //左键
                if(event.button === 0){
                    this.isSelecting = false;
                }
            },
            // 获取单元格位置
            getCellPosition(cell) {
                try{
                    while(cell.tagName !== 'TD'){
                        cell = cell.parentElement;
                    }
                    const rowIndex2 = cell.parentElement.rowIndex;
                    const cellIndex2 = cell.cellIndex;
                    const test = cell.getAttribute("data-colid");
                    let visibleColumn=this.getTablexGrid().getTableColumn()["visibleColumn"];
                    const cellIndex = visibleColumn.findIndex((col)=>{
                        return col.id==cell.getAttribute("data-colid");
                    })
                    let visibleData=this.getTablexGrid().getTableData()["visibleData"];
                    const rowIndex =visibleData.findIndex((row)=>{
                        return row._XID==cell.parentElement.getAttribute("data-rowid");
                    })
                    return { rowIndex, cellIndex };
                }catch(e){
                    return { rowIndex:-1,cellIndex:-1};
                }
            },
            //设置框打开
            setselectedCellArea(){
                //this.$nextTick(()=>{
                try{

                    let startRowIndex=this.selectionStart["rowIndex"];
                    let endRowIndex=this.selectionEnd["rowIndex"];
                    let startColumnIndex=this.selectionStart["cellIndex"];
                    let endColumnIndex=this.selectionEnd["cellIndex"];
                    let {width,height,left,top,leftFixedWidth,rightFixedWidth,mainWidth,rightFixedLeft}=this.getAreaBoxPostion();
                    // .vxe-table--fixed-wrapper .vxe-table--body-wrapper
                    // .vxe-table--main-wrapper .vxe-table--body-wrapper
                    var activeElement=this.getTablexGrid().$el.querySelector(".vxe-table--main-wrapper .vxe-table--body-wrapper .vxe-table--cell-active-area");
                    var mainElement=this.getTablexGrid().$el.querySelector(".vxe-table--main-wrapper .vxe-table--body-wrapper .vxe-table--cell-main-area");
                    var leftfixedActiveElement=this.getTablexGrid().$el.querySelector(".vxe-table--fixed-wrapper .vxe-table--fixed-left-wrapper .vxe-table--body-wrapper .vxe-table--cell-active-area");
                    var leftfixedMainElement=this.getTablexGrid().$el.querySelector(".vxe-table--fixed-wrapper .vxe-table--fixed-left-wrapper .vxe-table--body-wrapper .vxe-table--cell-main-area");
                    var rightfixedActiveElement=this.getTablexGrid().$el.querySelector(".vxe-table--fixed-wrapper .vxe-table--fixed-right-wrapper .vxe-table--body-wrapper .vxe-table--cell-active-area");
                    var rightfixedMainElement=this.getTablexGrid().$el.querySelector(".vxe-table--fixed-wrapper .vxe-table--fixed-right-wrapper .vxe-table--body-wrapper .vxe-table--cell-main-area");
                    //获取固定列宽度fixed--hidden
                    var fixedWidth=0;
                    let flexDiv=this.getTablexGrid().$el.querySelector(".vxe-table--fixed-left-wrapper");
                    if(flexDiv){
                        fixedWidth=flexDiv.offsetWidth;
                    }
                    var elements=[activeElement,mainElement,leftfixedActiveElement,leftfixedMainElement];
                    elements.forEach((element)=>{
                        if(element){
                            element.style.width=`${width}px`;
                            element.style.height=`${height}px`;
                            element.style.top=`${top}px`;
                            element.style.left=`${left}px`;
                            element.style.display="block";
                        }
                    })
                    //如果选择的索引位置大于等于右侧固定的位置
                    //获取右侧固定的索引位置
                    let rightFixedIndex=this.getrightFixedIndex();
                    if(rightFixedIndex>-1&&endColumnIndex>=rightFixedIndex){
                        elements=[rightfixedActiveElement,rightfixedMainElement];
                        elements.forEach((element)=>{
                            if(element){
                                element.style.width=`${rightFixedWidth}px`;
                                element.style.height=`${height}px`;
                                element.style.top=`${top}px`;
                                element.style.left=`${rightFixedLeft}px`;
                                element.style.display="block";
                            }
                        })
                    }
                    this.openAreaBox();
                    this.selectionStart={"cellIndex":startColumnIndex,"rowIndex":startRowIndex};
                    this.selectionEnd={"cellIndex":endColumnIndex,"rowIndex":endRowIndex};
                }catch(e){

                }
                //});

            },
            getrightFixedIndex(){
                let visibleColumn=this.getTablexGrid().getTableColumn()["visibleColumn"];
                return visibleColumn.findIndex((col)=>{
                    return col.fixed=="right";
                })
            },
            //根据开始位置和结束位置的索引计算框的width,height,left,top
            getAreaBoxPostion(){
                let startRowIndex=this.selectionStart["rowIndex"];
                let endRowIndex=this.selectionEnd["rowIndex"];
                let startColumnIndex=this.selectionStart["cellIndex"];
                let endColumnIndex=this.selectionEnd["cellIndex"];
                let visibleColumn=this.getTablexGrid().getTableColumn()["visibleColumn"];
                let visibleData=this.getTablexGrid().getTableData()["visibleData"];
                if(startColumnIndex<0||endColumnIndex<0||startRowIndex<0||endRowIndex<0)return;
                var maxColumnIndex=visibleColumn.length-1;
                var maxRowIndex=visibleData.length-1;
                if(endColumnIndex>maxColumnIndex){
                    endColumnIndex=maxColumnIndex;
                }
                if(endRowIndex>maxRowIndex){
                    endRowIndex=maxRowIndex;
                }
                // height width left top display
                // cellarea
                let width=0,height=0,left=0,top=0,leftFixedWidth=0,rightFixedWidth=0,mainWidth=0,rightFixedLeft=0,leftFixedLeft=0;
                let fixedwidth=0,fixedheight=0,fixedleft=0,fixedtop=0;

                for (let index = 0; index < visibleColumn.length; index++) {
                    let col = visibleColumn[index]
                    let colid = col.id;
                    let columnWidthTemp = this.getTablexGrid().getColumnById(colid).renderWidth;
                    if(columnWidthTemp == undefined) {
                        columnWidthTemp = 0;
                    }
                    if(index<startColumnIndex){
                        left+=columnWidthTemp;
                        if(col.fixed=="left"){
                            leftFixedLeft+=columnWidthTemp;
                        }else if(col.fixed=="right"){
                            rightFixedLeft+=columnWidthTemp;
                        }
                    }
                    if(index<=endColumnIndex&&startColumnIndex<=index){
                        width+=columnWidthTemp;
                        if(col.fixed=="left"){
                            leftFixedWidth+=columnWidthTemp;
                        }else if(col.fixed=="right"){
                            rightFixedWidth+=columnWidthTemp;
                        }else{
                            mainWidth+=columnWidthTemp;
                        }
                    }
                }

                height=(endRowIndex-startRowIndex+1)*this.gridOptions["row-config"]["height"];
                if(height<=0||width<=0){
                    this.destroyAreaBox();
                    return;
                }
                top=startRowIndex*this.gridOptions["row-config"]["height"];
                return {width,height,left,top,leftFixedWidth,rightFixedWidth,mainWidth,rightFixedLeft,leftFixedLeft};
            },
            //显示范围框
            openAreaBox(){
                var element=this.getTablexGrid().$el.querySelector(".vxe-table--main-wrapper .vxe-table--body-wrapper .vxe-table--cell-area");
                if(element){
                    element.style.display="block";
                }
                element=this.getTablexGrid().$el.querySelector(".vxe-table--fixed-wrapper .vxe-table--fixed-left-wrapper .vxe-table--body-wrapper .vxe-table--cell-area");
                if(element){
                    element.style.display="block";
                }
                let rightFixedIndex=this.getrightFixedIndex();
                if(rightFixedIndex>-1&&this.selectionEnd["cellIndex"]>=rightFixedIndex){
                    element=this.getTablexGrid().$el.querySelector(".vxe-table--fixed-wrapper .vxe-table--fixed-right-wrapper .vxe-table--body-wrapper .vxe-table--cell-area");
                    if(element){
                        element.style.display="block";
                    }
                }
            },
            //关闭范围框
            closeAreaBox(){
                var element=this.getTablexGrid().$el.querySelector(".vxe-table--main-wrapper .vxe-table--body-wrapper .vxe-table--cell-area");
                if(element){
                    element.style.display="none";
                }
                element=this.getTablexGrid().$el.querySelector(".vxe-table--fixed-wrapper .vxe-table--fixed-left-wrapper .vxe-table--body-wrapper .vxe-table--cell-area");
                if(element){
                    element.style.display="none";
                }
                element=this.getTablexGrid().$el.querySelector(".vxe-table--fixed-wrapper .vxe-table--fixed-right-wrapper .vxe-table--body-wrapper .vxe-table--cell-area");
                if(element){
                    element.style.display="none";
                }
            },
            //销毁范围框
            destroyAreaBox(){
                this.selectionStart={"rowIndex":-1,"cellIndex":-1};
                this.selectionEnd={"rowIndex":-1,"cellIndex":-1};
                this.closeAreaBox();
            },
            tableKeydown({$event}){
                this.tbodykeydown($event);
            },
            tbodykeydown(event){
                let tablexgrid=this.getTablexGrid();
                let tableColumn=this.getTablexGrid().getTableColumn()["visibleColumn"];
                let tableData=this.getTablexGrid().getTableData()["visibleData"];
                let startRowIndex=this.selectionStart["rowIndex"];
                let endRowIndex=this.selectionEnd["rowIndex"];
                let startColumnIndex=this.selectionStart["cellIndex"];
                let endColumnIndex=this.selectionEnd["cellIndex"];
                var maxColumnIndex=tableColumn.length-1;
                var maxRowIndex=tableData.length-1;
                var minColumnIndex=0;
                var minRowIndex=0;

                if (event.ctrlKey && event.keyCode === 67) {
                    //ctrl+c 复制
                    this.contextMenuClickEvent({menu:{code:"cellCopy"}});
                    event.preventDefault();
                }
            },
            contextMenuClickEvent({menu,row,column,rowIndex,columnIndex,$event}){
                let startRowIndex=this.selectionStart["rowIndex"];
                let endRowIndex=this.selectionEnd["rowIndex"];
                let startColumnIndex=this.selectionStart["cellIndex"];
                let endColumnIndex=this.selectionEnd["cellIndex"];
                let visibleColumnData = this.getTablexGrid().getTableColumn()["visibleColumn"];
                var tableData=this.getTablexGrid().getTableData()["visibleData"];
                switch(menu.code){
                    //复制
                    case "cellCopy":
                        let enterStr="\r\n";
                        let spaceStr="\t";
                        let data=[];
                        for(var i=startRowIndex;i<=endRowIndex;i++){
                            let value=[];
                            for(var j=startColumnIndex;j<=endColumnIndex;j++){
                                value.push(tableData[i][visibleColumnData[j].property]);
                            }
                            data.push(value);
                        }
                        let finalStr=data.map((value)=>{
                            return value.join(spaceStr);
                        }).join(enterStr);
                        this.copyValue(finalStr);
                        break;

                }
            },

            //复制的工具方法
            copyValue(value){
                if (XEClipboard.copy(value)) {
                    this.$message.success(this.$t('generic.copySuccess'));
                }
            },
            /*===================================Slide to select end========================================================*/

        }
    }
</script>

<style scoped>
    .mytable-style .vxe-body--row.row-green {
        background-color: darkseagreen;
        color: #333;
    }

    .scanpackHeader {
        display: flex;
        align-items: center;
        justify-content: left;
    }
    .tl-span{
        width: 80px;
        font-size: 12px;
        overflow: hidden;
        display: inline-block;
        white-space: nowrap;
        font-weight: bold;
        padding-right: 3px;
        text-align: right;
    }
    .tl-btn {
        margin-top: 10px;
        margin-right: 5px;
    }
    .scanpackTitle {
        font-size: 12px;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        text-align: right;
        color: rgba(0, 0, 0, 0.85);
        font-weight: bold;
    }
    .scanCodeTile {
        font-size: 12px;
        text-align: center;
    }

</style>
<style scoped>
    .un-select-vxe-table {
        -webkit-user-select: none; /* Safari */
        -moz-user-select: none; /* Firefox */
        -ms-user-select: none; /* Internet Explorer/Edge */
        user-select: none;
    }
    .flex-center{
        display: flex;
        align-items: center;
    }
</style>
